// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:15:39.244Z
// Property: San Remo Apartments (ID: 6737460151191768)
// Collections: 25 amenities, 5 floorplans (live), 38 photos, 84 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191768",
  "property_external_id": "4871558",
  "property_zillow_url": "https://www.zillow.com/homedetails/1502-Partnership-Way-Katy-TX-77449/2084980011_zpid/",
  "property_apartments_url": "https://www.apartments.com/san-remo-apartments-katy-tx/kwet13b",
  "property_google_business_url": "https://www.google.com/maps/place/San+Remo/data=!4m2!3m1!1s0x0:0x305fffeeb818797a?sa=X&ved=2ahUKEwiSmtDRvrySAxUPRzABHf_uNTQQ_BJ6BAhFEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17320117039",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "san-remo-apartments",
  "property_name": "San Remo Apartments",
  "property_website_url": "https://www.sanremo-houston.com/",
  "property_domain": "https://www.sanremo-houston.com/",
  "property_address": "1502 Partnership Way",
  "property_full_address": "1502 Partnership Way, Katy, TX 77449",
  "property_address_1": "1502 Partnership Way",
  "property_address_2": null,
  "property_address_city": "Katy",
  "property_address_state": "TX",
  "property_address_zip_full": "77449-5958",
  "property_address_zip": "77449",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "Bear Creek/Copperfield",
  "property_address_latitude": "29.7952208",
  "property_address_longitude": "-95.7711325",
  "property_email": "sanremo@rreafresidential.com",
  "property_phone": "(281) 846-1870",
  "property_call_tracking_phone": "281-612-7430",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your ideal living space at San Remo Apartments in Katy, TX, offering stylish one and two-bedroom floor plans. Enjoy top-notch amenities including a refreshing pool, state-of-the-art fitness center, relaxing spa, cozy lounge, and a dog park for your furry friends. Find your new home today—browse our availability or schedule a tour!",
  "property_long_description": "Welcome to San Remo Apartments, your premier destination for modern living in the heart of Katy, TX! Our community features a selection of thoughtfully designed floor plans, offering spacious one and two-bedroom apartments that perfectly suit your lifestyle. Experience the comfort of home with contemporary finishes, ample natural light, and private balconies that cater to both relaxation and entertainment. \n\nAt San Remo Apartments, we pride ourselves on providing top-tier amenities to enhance your living experience. Dive into our shimmering pool, perfect for hot Texas days, or stay fit in our state-of-the-art fitness center. Unwind in our luxurious lounge, indulge in spa days, or take your furry friend for a romp in our on-site dog park. We’ve created a vibrant community where leisure and convenience meet, allowing you to enjoy your best life.\n\nLocated in the desirable area of Katy, you’ll have easy access to shopping, dining, and entertainment options that make everyday living a breeze. Whether you’re looking for a tranquil retreat or an active lifestyle, San Remo Apartments offers the perfect blend of comfort and convenience.\n\nFind your new home today at San Remo Apartments—browse our availability or schedule a tour to visit our beautiful community! Your perfect apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-dc7c-77bf-85ce-802363b23746.webp",
  "property_featured_image_media": {
    "alt_text": "Luxury apartment complex outdoor swimming pool with tanning ledges and lounge chairs.",
    "public_id": "019e1e27-dc7c-77bf-85ce-802363b23746",
    "storage_key": "property/6737460151191768/019e1e27-dc7c-77bf-85ce-802363b23746.webp",
    "width": 1500,
    "height": 1000
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "333",
  "property_year_built": "2018",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.1921921921922",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "One-Time Move-In Fees\nAdministrative Fee\n$175\nApplication Fee\n$65",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "If animals are accepted at the RREAF Residential community where application is made, no more than two animals are allowed per apartment. Aggressive breeds will not be allowed.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://sanremoapartments.loftliving.com/login",
  "property_apply_now_url": "https://8754827.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-b8cf-74dd-862c-314f7cbd797c.webp",
  "property_primary_logo_media": {
    "alt_text": "San Remo logo",
    "public_id": "019e1e27-b8cf-74dd-862c-314f7cbd797c",
    "storage_key": "property/6737460151191768/019e1e27-b8cf-74dd-862c-314f7cbd797c.webp",
    "width": 368,
    "height": 346
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-b899-73d9-a6bc-40b75ed8ccca.webp",
  "property_secondary_logo_media": {
    "alt_text": "San Remo logo",
    "public_id": "019e1e27-b899-73d9-a6bc-40b75ed8ccca",
    "storage_key": "property/6737460151191768/019e1e27-b899-73d9-a6bc-40b75ed8ccca.webp",
    "width": 368,
    "height": 346
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-b899-73d9-a6bc-40b75ed8ccca.webp",
  "property_mono_white_logo_media": {
    "alt_text": "San Remo logo",
    "public_id": "019e1e27-b899-73d9-a6bc-40b75ed8ccca",
    "storage_key": "property/6737460151191768/019e1e27-b899-73d9-a6bc-40b75ed8ccca.webp",
    "width": 368,
    "height": 346
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-b955-778d-92bd-fb8219aeea66.webp",
  "property_mono_black_logo_media": {
    "alt_text": "San Remo logo",
    "public_id": "019e1e27-b955-778d-92bd-fb8219aeea66",
    "storage_key": "property/6737460151191768/019e1e27-b955-778d-92bd-fb8219aeea66.webp",
    "width": 368,
    "height": 346
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#c5cb50",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "725 - 1207",
  "property_sqft_min": "725",
  "property_sqft_max": "1207",
  "property_price_range": "1150 - 1774",
  "property_price_min": "1150",
  "property_price_max": "1774",
  "property_available_units": 26,
  "property_facebook_url": "https://www.facebook.com/people/San-Remo-Apartments/61554382298362/",
  "property_instagram_url": "https://www.instagram.com/san_remo_rrliving",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJfyMLjv0mQYYRenkYuO7_XzA",
  "property_youtube_url": "https://www.youtube.com/shorts/odRh0o5Zexo",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Katy%2C+TX",
  "property_tiktok_url": "https://www.tiktok.com/@sanremohouston",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to San Remo Apartments",
  "property_home_romance_title": "Embrace Your Dream Lifestyle in Our Beautiful Apartment Community",
  "property_home_amenities_blurb": "<p><a href=\"/floor-plans/\">San Remo Apartments</a> is here to introduce a higher standard of apartment living in the heart of Katy, Texas. Our brand new community is ideally situated just west of Houston, adjacent to Highway 99 and Interstate 10, making it easy to experience the best that Texas has to offer. Your favorite destinations are all within reach, including Typhoon Texas Waterpark. There’s always somewhere to explore from our convenient location.</p>",
  "property_home_floorplans_blurb": "<p>Located in Katy, TX, we offer stunning <a href=\"/floor-plans/\">1- and 2-bedroom</a> apartment homes with open floorplans, contemporary design, and <a href=\"/amenities/\">stylish finishes</a>. San Remo is more than just a place to live, it is a lifestyle.</p>",
  "property_home_gallery_blurb": "At San Remo Apartments in Katy, TX, a vibrant lifestyle awaits! Choose from spacious one and two-bedroom floor plans featuring modern amenities like granite countertops, stainless steel appliances, and walk-in closets. Enjoy our pet-friendly community with a fitness center, refreshing pool, and engaging social events. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding San Remo Apartments in Katy, TX! Explore local favorites, dining, and nearby attractions that enhance your living experience. Choose from our spacious one and two-bedroom floor plans and embrace a lifestyle full of convenience. See what's around our community today!",
  "property_home_reviews_blurb": "At San Remo Apartments in Katy, TX, residents rave about our vibrant community and exceptional amenities. One resident shares, “I absolutely love the area. The food truck events and services like massages make it special!” Experience the blend of comfort and excitement—see what our residents have to say!",
  "property_neighborhood_blurb": "<p>Located in Katy, TX, we offer stunning <a href=\"/floor-plans/\">1- and 2-bedroom</a> apartment homes with open floorplans, contemporary design, and <a href=\"/amenities/\">stylish finishes</a>. San Remo is more than just a place to live, it is a lifestyle.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>We provide chic social areas where you can gather with friends and neighbors and a host of other community amenities to enhance your apartment living experience. Lounge at our iMac Net Cafe, or get work done at our business center. Exercise in our state-of-the-art fitness center or shimmering swimming pool before relaxing at outdoor verandas. Your pets are welcome to enjoy our bark park and life at San Remo Apartments. <a href=\"tel:281-612-7430\">Call to schedule a tour today</a>!</p>",
  "property_applynow_blurb": "Discover your perfect oasis at San Remo Apartments in Katy, TX! With spacious one and two-bedroom floor plans, you'll find comfort and style. Enjoy resort-style amenities, including a pool, fitness center, lounge, spa, and dog park. Explore all we offer and **lease online today** to find your new home!",
  "property_contactus_blurb": "Discover your ideal living space at San Remo Apartments in Katy, TX. Choose from our thoughtfully designed one and two-bedroom floor plans crafted for comfort and style. Ready to find out more? Have questions? Contact our leasing team today for assistance and to schedule a tour of our vibrant community!",
  "property_faqs_blurb": "At San Remo Apartments in Katy, TX, we offer spacious one and two-bedroom floor plans designed for your comfort. Have questions? Explore our Frequently Asked Questions page to discover everything you need to know about our vibrant community. Browse today and find your perfect home!",
  "property_floorplans_blurb": "<p>Choose from six floor plans with one and two-bedroom apartments for rent in Katy, TX. Each home is appointed with <a href=\"/amenities/\">contemporary accents</a> creating a space you can truly call home. With a chef-inspired kitchen, you’ll be able to prep and create delectable dishes with ease. Enjoy <a href=\"/gallery/\">other details</a> of your new apartment home, like 9-foot ceilings, air conditioning, ceiling fans, and a washer and dryer. Designed to complement your lifestyle, our layouts are guaranteed to satisfy.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Discover your perfect home at San Remo Apartments in Katy, TX! Choose from spacious one and two-bedroom floor plans, with exceptional amenities like a refreshing pool, fitness center, lounge, spa, and dog park. Explore our interactive community map to search available apartments and find your ideal living space today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Welcome to San Remo Apartments in Katy, TX! Explore our spacious one and two-bedroom floor plans designed for modern living. Great friends make great neighbors—refer a friend to our community today and experience the joy of exceptional apartment living together. Discover the perfect home for you both!",
  "property_residentaccess_blurb": "Welcome to San Remo Apartments in Katy, TX! Explore our spacious one and two-bedroom floor plans designed for your comfort and lifestyle. Access your resident portal now to conveniently pay rent, schedule maintenance, and stay updated on community happenings. Join us and experience the pinnacle of apartment living!",
  "property_reviews_blurb": "At San Remo Apartments in Katy, TX, our residents enjoy a vibrant lifestyle blended with top-notch amenities. As one happy resident shares, \"It's a wonderful location, and all of the amenities are great.\" Experience the community where comfort meets convenience. See what our residents have to say about living at our community!",
  "property_created_at": "1752257094063",
  "property_scheduletour_blurb": "Discover your ideal home at San Remo Apartments in Katy, TX! Choose from spacious one and two-bedroom floor plans tailored to your lifestyle. Ready to see why residents love living here? Schedule a tour today and explore all our community has to offer! View all floor plans online!",
  "property_thankyou_blurb": "Thank you for your interest in San Remo Apartments in Katy, TX! Explore our spacious one and two-bedroom floor plans, designed with your comfort in mind. A member of our team will contact you shortly to assist with your inquiries. Discover your ideal living space today!",
  "property_virtualtours_blurb": "<p>At San Remo, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. San Remo Apartments",
  "property_seo_title_home": "San Remo Apartments | Apartments in Katy, TX",
  "property_seo_description_home": "Discover your ideal living space at San Remo Apartments in Katy, TX! Choose from our spacious one and two-bedroom floor plans, complemented by exceptional amenities including a sparkling pool, state-of-the-art fitness center, cozy lounge, relaxing spa, and a welcoming dog park. Experience comfort and convenience in a vibrant community. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Katy, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at San Remo Apartments in Katy, TX! Explore our diverse floor plans featuring stylish One Bedroom and spacious Two Bedroom options. Browse our available apartment homes today and find the perfect floor plan that fits your lifestyle. Your dream apartment awaits!",
  "property_seo_title_amenities": "Amenities | Katy, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury living at San Remo Apartments in Katy, TX! Choose from spacious one and two-bedroom floor plans, and enjoy a host of top-notch amenities including a sparkling pool, state-of-the-art fitness center, relaxing lounge, rejuvenating spa, and a delightful dog park. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Katy, TX",
  "property_seo_description_gallery": "Discover your dream home at San Remo Apartments in Katy, TX. Explore stunning photo galleries showcasing our spacious one and two-bedroom floor plans, and indulge in exceptional amenities like a refreshing pool, state-of-the-art fitness center, relaxing lounge, rejuvenating spa, and a fun dog park. Picture yourself living here—your perfect apartment awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | San Remo Apartments Apartments",
  "property_seo_description_virtualtours": "Explore San Remo Apartments in Katy, TX, where comfort meets style! Discover our thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Take a virtual tour of our beautiful community and apartments for rent today, and find your perfect home!",
  "property_seo_title_interactivemap": "Interactive Map | San Remo Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at San Remo Apartments in Katy, TX! Explore our interactive community map to view spacious one and two-bedroom floor plans. Enjoy top-notch amenities like a refreshing pool, state-of-the-art fitness center, cozy lounge, rejuvenating spa, and a fun dog park. Start your journey by finding available apartments and pricing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Katy, TX",
  "property_seo_description_neighborhood": "Discover the vibrant community surrounding San Remo Apartments in Katy, TX! Explore our one and two-bedroom floor plans while enjoying easy access to local favorites and points of interest. See what's around our community and experience the best of Katy living!",
  "property_seo_title_contact": "Contact Us | San Remo Apartments",
  "property_seo_description_contact": "\"Discover your perfect home at San Remo Apartments in Katy, TX! Explore our diverse floor plans including stylish one and two-bedroom options. Have questions? Contact our leasing team today for personalized assistance and to schedule a tour!\"",
  "property_seo_title_faqs": "FAQs | Apartments in Katy, TX",
  "property_seo_description_faqs": "Discover the answers to your questions about San Remo Apartments in Katy, TX! Explore our one and two-bedroom floor plans, and learn about our fantastic amenities, including a refreshing pool, state-of-the-art fitness center, relaxing lounge, rejuvenating spa, and a dog park for your furry friends. Browse our FAQs page today for helpful insights into our vibrant community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Katy, TX",
  "property_seo_description_reviews": "Discover the vibrant lifestyle at San Remo Apartments in Katy, TX! Explore our spacious one and two-bedroom floor plans, complemented by luxurious amenities including a pool, fitness center, lounge, spa, and dog park. Don't just take our word for it – see what our residents have to say about living in our community! Join us today and experience exceptional living at San Remo.",
  "property_seo_title_applynow": "Apply Now | Apartments in Katy, TX",
  "property_seo_description_applynow": "Discover your perfect home at San Remo Apartments in Katy, TX! Choose from spacious one and two-bedroom floor plans, all featuring top-notch amenities like a refreshing pool, state-of-the-art fitness center, relaxing lounge, rejuvenating spa, and a welcoming dog park. Ready to take the next step? Apply now and lease online today to secure your ideal apartment!",
  "property_seo_title_residentaccess": "Resident Access | San Remo Apartments",
  "property_seo_description_residentaccess": "\"Welcome to San Remo Apartments in Katy, TX! Access your resident portal to easily pay rent, schedule maintenance, and stay connected with your community. Log in now for a seamless living experience!\"",
  "property_seo_title_referafriend": "Refer A Friend | San Remo Apartments",
  "property_seo_description_referafriend": "\"Refer a friend to San Remo Apartments in Katy, TX! Enjoy a vibrant community where great friends make great neighbors. Spread the word and unlock exclusive perks today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | San Remo Apartments",
  "property_seo_description_scheduletour": "\"Discover your ideal home at San Remo Apartments in Katy, TX! Schedule a tour today to explore our beautifully designed community, luxurious amenities, and vibrant lifestyle. Don’t miss your chance to experience the perfect blend of comfort and convenience!\"",
  "property_seo_title_privacy": "Privacy Policy | San Remo Apartments",
  "property_seo_description_privacy": "\"Discover peace of mind at San Remo Apartments in Katy, TX. Our privacy policy outlines how we protect your personal information while you enjoy our vibrant community. Your privacy matters—view our policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | San Remo Apartments",
  "property_seo_description_accessibility": "\"Discover San Remo Apartments in Katy, TX, where we prioritize accessibility for all. Our commitment to digital inclusion ensures everyone can enjoy our vibrant community. Learn more about our accessibility features and join us in creating an inclusive living experience. Explore today!\"",
  "property_seo_title_sitemap": "Sitemap | San Remo Apartments",
  "property_seo_description_sitemap": "\"Explore the San Remo Apartments in Katy, TX! Our sitemap provides a comprehensive overview of our community amenities, floor plans, and services. Discover your new home today and see why San Remo is the ideal choice for vibrant living. View our website sitemap now!\"",
  "property_seo_title_thankyou": "Thank You | San Remo Apartments",
  "property_seo_description_thankyou": "Thank you for your interest in San Remo Apartments in Katy, TX! Your submission has been received, and a member of our friendly team will reach out to you shortly. Discover your ideal home in our vibrant community with exceptional amenities and a welcoming atmosphere.",
  "property_seo_title_pets": "Pet Policy | Apartments in Katy, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293616279",
  "amenities": [
    {
      "id": "ec_6beaa9dd7cbbc3a03dd355d7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_796298775942b70976b98922",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77db7bc60e6058dcf18f00fb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c0cbdd2b9c3a10f51b36aa43",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Easy Access to Shopping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_930665ce5d6f2a089dc88150",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Gated Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a23ef3aed12138e0dc9cb103",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "iMac Net Cafe",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4cd79614d62770ffa9d8fbc1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "On‑call Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f195a6c04e10d2e62305230c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "On‑site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a4722f8f238d3a412a20a0f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Outdoor Verandas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fbbb7e92db3b19daf99491ca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a5238b73d2dbf3f3309fd6b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1c2b4fb785934373a6a185d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "State‑of‑the‑Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45562e340ed5aab9c5cea053",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Dog Park With Dog Wash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd416e61d87dc2b0df161059",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Conference Rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2434b778cf940d117495a58d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c24a9b5ef44fd87ab672c36",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "24‑hour Package Pickup",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_281abbebf281e9b39dc9dc57",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "9Ft Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6722c101103bd666762bcd16",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b1109b9625b56fa882ecc84",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "All‑electric kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_158786da5ed2f8f81e5b6a5d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7d1e1ff9610939beff9bb77",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a58a9af45569c0278f76f538",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_32bb06515609fdc7631b5a76",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer in Home",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8a66e407dcdc8e175a6b613",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_10682e56db5278de8cc3a586",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_bd9f200a-0305-4b65-bb4a-68329752e3e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-b883-73fa-9b77-8db2653f2290.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub area with lounge chairs and cabanas.",
        "public_id": "019e84a4-b883-73fa-9b77-8db2653f2290",
        "storage_key": "property/6737460151191768/019e84a4-b883-73fa-9b77-8db2653f2290.webp",
        "width": 3072,
        "height": 2305
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our stunning resort-style pool, complete with a soothing hot tub, ample lounge seating, and shaded cabanas.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and hot tub area with lounge chairs and cabanas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_52b60746-51e1-4a51-bb12-5605fae53a58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-5137-75db-82a4-c2ef561b2cfd.webp",
      "image_media": {
        "alt_text": "Outdoor oversized chess board with benches and covered seating area in the background.",
        "public_id": "019e84a4-5137-75db-82a4-c2ef561b2cfd",
        "storage_key": "property/6737460151191768/019e84a4-5137-75db-82a4-c2ef561b2cfd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a game of chess on the oversized outdoor chess board, relax on the benches, or gather under the covered pavilion with grilling stations.",
      "link": "",
      "alt_text": "Outdoor oversized chess board with benches and covered seating area in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bd6e1678-bf86-4c4c-8807-637e2196c613",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/01a09164-f3c6-764b-8db6-c183b44cd09a.webp",
      "image_media": {
        "alt_text": "Open concept living and kitchen area with a sectional sofa, coffee table, and kitchen island with bar stools. A bedroom is visible in the background.",
        "public_id": "01a09164-f3c6-764b-8db6-c183b44cd09a",
        "storage_key": "property/6737460151191768/01a09164-f3c6-764b-8db6-c183b44cd09a.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area flows seamlessly into a modern kitchen. Perfect for entertaining and comfortable everyday living.",
      "link": "",
      "alt_text": "Open concept living and kitchen area with a sectional sofa, coffee table, and kitchen island with bar stools. A bedroom is visible in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9468bc28-6ff8-4cea-ae76-b7a544111197",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/01a09164-f447-72ba-bc05-fe77565f2194.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinetry, granite countertops, stainless steel appliances, and an island with bar stools.",
        "public_id": "01a09164-f447-72ba-bc05-fe77565f2194",
        "storage_key": "property/6737460151191768/01a09164-f447-72ba-bc05-fe77565f2194.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in this stunning modern kitchen, featuring sleek dark cabinetry, elegant granite countertops, and top-of-the-line stainless steel appliances. The spacious island with bar stools is perfect for casual dining or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinetry, granite countertops, stainless steel appliances, and an island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bafaaef2-cd39-4e6e-a525-a322e1fdc6b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/01a09164-f439-7503-8a63-d97675795504.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with island, stainless steel appliances, and a view into a bedroom.",
        "public_id": "01a09164-f439-7503-8a63-d97675795504",
        "storage_key": "property/6737460151191768/01a09164-f439-7503-8a63-d97675795504.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience sophisticated living in this open-concept apartment, featuring a sleek kitchen with an island, a spacious dining area, and a comfortable bedroom.",
      "link": "",
      "alt_text": "Modern kitchen and dining area with island, stainless steel appliances, and a view into a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c101095a-1efc-4059-97c7-7b9db34217d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/01a09164-efdf-77ea-9a14-dc450843c246.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, dresser, and large window.",
        "public_id": "01a09164-efdf-77ea-9a14-dc450843c246",
        "storage_key": "property/6737460151191768/01a09164-efdf-77ea-9a14-dc450843c246.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious and inviting bedroom featuring a comfortable king-size bed, elegant nightstands, a modern dresser, and a large window providing ample natural light.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, dresser, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_31187955-1240-42e8-8842-9ae5688cebbf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/01a09164-f3c9-76f5-82be-58ac72d101f4.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "01a09164-f3c9-76f5-82be-58ac72d101f4",
        "storage_key": "property/6737460151191768/01a09164-f3c9-76f5-82be-58ac72d101f4.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience luxury and comfort in our modern bathrooms, featuring spacious vanities, sleek finishes, and elegant fixtures. A perfect retreat after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a6a9f13d-1d36-4c28-a99d-414a65e7228f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/01a09164-f446-7556-93e7-3fddc65605ed.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with shower.",
        "public_id": "01a09164-f446-7556-93e7-3fddc65605ed",
        "storage_key": "property/6737460151191768/01a09164-f446-7556-93e7-3fddc65605ed.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Step into this clean and modern bathroom, featuring a spacious vanity with granite countertops, a comfortable toilet, and a pristine bathtub with an integrated shower.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cd8b931a-ff1f-41ed-853f-11650730eaad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/01a09164-eb16-73c9-93c7-aa3cdf5edf44.webp",
      "image_media": {
        "alt_text": "Open concept living area and kitchen with island seating and dining table.",
        "public_id": "01a09164-eb16-73c9-93c7-aa3cdf5edf44",
        "storage_key": "property/6737460151191768/01a09164-eb16-73c9-93c7-aa3cdf5edf44.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area and kitchen featuring a large island with seating, a dining table, and modern appliances.",
      "link": "",
      "alt_text": "Open concept living area and kitchen with island seating and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0176841a-1063-46d2-b35b-0c19beccc42f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/01a09164-ed94-757a-a10f-afe4230db266.webp",
      "image_media": {
        "alt_text": "Living and dining area with large windows, ceiling fan, and modern furniture.",
        "public_id": "01a09164-ed94-757a-a10f-afe4230db266",
        "storage_key": "property/6737460151191768/01a09164-ed94-757a-a10f-afe4230db266.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring abundant natural light from large windows, a ceiling fan, and elegant furnishings perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living and dining area with large windows, ceiling fan, and modern furniture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c06ac0d0-4faa-4b38-aadc-280d529393b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-78bf-753e-9878-3bfdeb0a5b37.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with dumbbells, weight machines, and punching bag.",
        "public_id": "019e84a4-78bf-753e-9878-3bfdeb0a5b37",
        "storage_key": "property/6737460151191768/019e84a4-78bf-753e-9878-3bfdeb0a5b37.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, free weights, and a boxing area for resident use.",
      "link": "",
      "alt_text": "Modern apartment gym with dumbbells, weight machines, and punching bag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_24c51a11-a9f9-4507-a2b5-41531508c281",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-7e28-7248-9f12-3bc0999918d9.webp",
      "image_media": {
        "alt_text": "Gym with dumbbells, weight machines, and punching bag.",
        "public_id": "019e84a4-7e28-7248-9f12-3bc0999918d9",
        "storage_key": "property/6737460151191768/019e84a4-7e28-7248-9f12-3bc0999918d9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a wide array of weight machines, free weights, and cardio equipment.",
      "link": "",
      "alt_text": "Gym with dumbbells, weight machines, and punching bag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b22283f3-d076-451e-bb26-9a2a7bed593d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/01a09164-edf9-779d-a327-0ae4391593dc.webp",
      "image_media": {
        "alt_text": "Modern lobby with coffee bar, dining table, seating area, and abstract art.",
        "public_id": "01a09164-edf9-779d-a327-0ae4391593dc",
        "storage_key": "property/6737460151191768/01a09164-edf9-779d-a327-0ae4391593dc.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "The stylish lobby of this apartment community features a coffee bar, a communal dining table, and comfortable seating, perfect for residents to relax or socialize.",
      "link": "",
      "alt_text": "Modern lobby with coffee bar, dining table, seating area, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eae1a7ce-7c0a-4c76-8fab-83aa761fc827",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/01a09164-edf9-779d-a327-07dfcd1f5e91.webp",
      "image_media": {
        "alt_text": "Modern apartment community lounge area with a full-service kitchen, plush seating, and view of the outdoor pool.",
        "public_id": "01a09164-edf9-779d-a327-07dfcd1f5e91",
        "storage_key": "property/6737460151191768/01a09164-edf9-779d-a327-07dfcd1f5e91.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and entertain in style in our beautifully appointed community lounge, featuring a gourmet kitchen, comfortable seating, and stunning views of the pool.",
      "link": "",
      "alt_text": "Modern apartment community lounge area with a full-service kitchen, plush seating, and view of the outdoor pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_478f149a-fe0e-4c55-ae23-fcbe40650cf0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-5458-708f-bdf2-1d6bb4ff5793.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with stainless steel appliances, dark wood cabinets, and a large dining table.",
        "public_id": "019e84a4-5458-708f-bdf2-1d6bb4ff5793",
        "storage_key": "property/6737460151191768/019e84a4-5458-708f-bdf2-1d6bb4ff5793.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience sophisticated living in this modern apartment featuring a gourmet kitchen with stainless steel appliances and ample cabinet space, adjacent to a stylish dining area perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen and dining area with stainless steel appliances, dark wood cabinets, and a large dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e3c76a6d-4824-4c28-88b7-3af2414033c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-4b85-744d-b5c4-5ad662e5e9a0.webp",
      "image_media": {
        "alt_text": "A king-sized bed with orange and white patterned comforter and blue pillows in a bedroom with a ceiling fan.",
        "public_id": "019e84a4-4b85-744d-b5c4-5ad662e5e9a0",
        "storage_key": "property/6737460151191768/019e84a4-4b85-744d-b5c4-5ad662e5e9a0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom featuring a king-sized bed, plush bedding, and a ceiling fan for year-round comfort. Large windows let in ample natural light.",
      "link": "",
      "alt_text": "A king-sized bed with orange and white patterned comforter and blue pillows in a bedroom with a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9064faac-fa00-425a-962e-9d7e4daa1e41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-4ef6-77b5-9eb6-e3868a18753c.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, granite countertops, and tiled shower.",
        "public_id": "019e84a4-4ef6-77b5-9eb6-e3868a18753c",
        "storage_key": "property/6737460151191768/019e84a4-4ef6-77b5-9eb6-e3868a18753c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience luxury in our modern bathrooms, featuring spacious vanities with granite countertops and elegant tiled shower surrounds.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, granite countertops, and tiled shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b6588d06-f4f3-4bee-ae64-bb20035edfb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-5193-769f-8fdc-c147933ff34e.webp",
      "image_media": {
        "alt_text": "Modern apartment community lounge with kitchen island and seating",
        "public_id": "019e84a4-5193-769f-8fdc-c147933ff34e",
        "storage_key": "property/6737460151191768/019e84a4-5193-769f-8fdc-c147933ff34e.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy the spacious and modern community lounge, featuring a stylish kitchen island, comfortable seating, and a business center with computers.",
      "link": "",
      "alt_text": "Modern apartment community lounge with kitchen island and seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_529ac85e-9da4-4a17-b459-f71f5fe22ea8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-5528-715f-a885-c55e7e343b25.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with large sectional sofa, coffee table, and large screen TV.",
        "public_id": "019e84a4-5528-715f-a885-c55e7e343b25",
        "storage_key": "property/6737460151191768/019e84a4-5528-715f-a885-c55e7e343b25.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax and unwind in our sophisticated lounge, featuring a spacious sectional sofa, modern coffee table, and a large screen television for your entertainment.",
      "link": "",
      "alt_text": "Stylish lounge area with large sectional sofa, coffee table, and large screen TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_78152ea6-2dbb-465a-8ef4-f2c23c1acc26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-b372-7507-8240-41a3608c3602.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex buildings and amenities including a pool and parking.",
        "public_id": "019e84a4-b372-7507-8240-41a3608c3602",
        "storage_key": "property/6737460151191768/019e84a4-b372-7507-8240-41a3608c3602.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "An aerial view showcases the expansive community amenities, including a sparkling swimming pool and ample parking, surrounded by modern apartment buildings.",
      "link": "",
      "alt_text": "Aerial view of apartment complex buildings and amenities including a pool and parking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_30d5f645-155a-4b5a-b7b3-cd9c9e9f935d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-ac9a-77ef-b4eb-5add90fa4bf5.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "019e84a4-ac9a-77ef-b4eb-5add90fa4bf5",
        "storage_key": "property/6737460151191768/019e84a4-ac9a-77ef-b4eb-5add90fa4bf5.webp",
        "width": 3072,
        "height": 2303
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f69cad9c-c0ca-4fc1-b3ec-e33b162b4b97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-b20e-744d-b5c2-8a954bb3654e.webp",
      "image_media": {
        "alt_text": "Outdoor amenities including a playground, covered pavilion, giant chess board, and fenced dog run.",
        "public_id": "019e84a4-b20e-744d-b5c2-8a954bb3654e",
        "storage_key": "property/6737460151191768/019e84a4-b20e-744d-b5c2-8a954bb3654e.webp",
        "width": 3072,
        "height": 2302
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our community amenities, featuring a playground, covered pavilion for gatherings, a unique giant chess board, and a dedicated dog run for your furry friends.",
      "link": "",
      "alt_text": "Outdoor amenities including a playground, covered pavilion, giant chess board, and fenced dog run.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a61b1dd-2a23-4a67-a03c-ce9e7f383d83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-a5d5-7223-8cef-092b021b91b2.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019e84a4-a5d5-7223-8cef-092b021b91b2",
        "storage_key": "property/6737460151191768/019e84a4-a5d5-7223-8cef-092b021b91b2.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our stunning outdoor pool, complete with comfortable lounge seating and lush landscaping.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7a976a93-c5b3-484f-aff3-354d812e6405",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-a763-72c7-be14-fad4361ce665.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and spa area with lounge chairs and cabanas.",
        "public_id": "019e84a4-a763-72c7-be14-fad4361ce665",
        "storage_key": "property/6737460151191768/019e84a4-a763-72c7-be14-fad4361ce665.webp",
        "width": 3072,
        "height": 2302
      },
      "title": "Community",
      "description": "Enjoy our stunning resort-style swimming pool and spa, complete with ample lounge seating and shaded cabanas for ultimate relaxation.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and spa area with lounge chairs and cabanas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_74546758-bd14-44e7-a29b-781da3cd0da2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-9e9a-71be-b165-71d9b1dc6dba.webp",
      "image_media": {
        "alt_text": "Playground with swings, slides, and tunnels.",
        "public_id": "019e84a4-9e9a-71be-b165-71d9b1dc6dba",
        "storage_key": "property/6737460151191768/019e84a4-9e9a-71be-b165-71d9b1dc6dba.webp",
        "width": 3072,
        "height": 2306
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, complete with swings, slides, and climbing structures.",
      "link": "",
      "alt_text": "Playground with swings, slides, and tunnels.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b0d2822b-768d-4f52-bd1a-f9088797af90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-91bc-754a-a152-9fa069cc9f6a.webp",
      "image_media": {
        "alt_text": "Covered parking lot with cars parked, alongside brick apartment buildings under a blue sky.",
        "public_id": "019e84a4-91bc-754a-a152-9fa069cc9f6a",
        "storage_key": "property/6737460151191768/019e84a4-91bc-754a-a152-9fa069cc9f6a.webp",
        "width": 3072,
        "height": 2306
      },
      "title": "Community",
      "description": "Ample covered parking is available for residents, conveniently located next to the apartment buildings. Enjoy easy access to your home and protection from the elements.",
      "link": "",
      "alt_text": "Covered parking lot with cars parked, alongside brick apartment buildings under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_78d13458-68d7-4ffb-9c43-f2e106358f6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-9396-7559-b97e-59fe48d9d279.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with multiple buildings, a pool, and parking areas.",
        "public_id": "019e84a4-9396-7559-b97e-59fe48d9d279",
        "storage_key": "property/6737460151191768/019e84a4-9396-7559-b97e-59fe48d9d279.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "An aerial view showcases the layout of a multifamily property, highlighting its apartment buildings, a central swimming pool with lounge areas, and ample parking spaces.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property with multiple buildings, a pool, and parking areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1a2fb12-9bfe-4ed4-8858-849c9aac78df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-7f21-70df-b8e1-8595d764b6e8.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with in-water lounge chairs and a spa area, surrounded by apartment buildings.",
        "public_id": "019e84a4-7f21-70df-b8e1-8595d764b6e8",
        "storage_key": "property/6737460151191768/019e84a4-7f21-70df-b8e1-8595d764b6e8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool featuring in-water lounge chairs and a relaxing spa area, perfect for unwinding.",
      "link": "",
      "alt_text": "Resort-style swimming pool with in-water lounge chairs and a spa area, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_396cfed4-b894-47c9-948a-03ecd3a6bb14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-7a64-774a-aa42-3ca5edb41468.webp",
      "image_media": {
        "alt_text": "San Remo apartment complex entrance with monument sign.",
        "public_id": "019e84a4-7a64-774a-aa42-3ca5edb41468",
        "storage_key": "property/6737460151191768/019e84a4-7a64-774a-aa42-3ca5edb41468.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Welcome to San Remo apartments. Discover our beautiful community located at 1502.",
      "link": "",
      "alt_text": "San Remo apartment complex entrance with monument sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3af44f40-0e80-4cdd-8c1a-0af963ff9870",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-6e89-7440-9c75-32ca2e93c11d.webp",
      "image_media": {
        "alt_text": "San Remo apartment complex entrance and parking lot.",
        "public_id": "019e84a4-6e89-7440-9c75-32ca2e93c11d",
        "storage_key": "property/6737460151191768/019e84a4-6e89-7440-9c75-32ca2e93c11d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "The San Remo apartment complex features a modern brick building with a welcoming entrance and adjacent parking lot.",
      "link": "",
      "alt_text": "San Remo apartment complex entrance and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c2c5b76-4226-4077-8bea-54fdcdd5dfc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-7b60-71df-8f72-fe3e521ed5c5.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019e84a4-7b60-71df-8f72-fe3e521ed5c5",
        "storage_key": "property/6737460151191768/019e84a4-7b60-71df-8f72-fe3e521ed5c5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool, perfect for relaxing and soaking up the sun. Surrounded by lush palm trees and comfortable lounge chairs, it's an oasis of tranquility.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_adfd2d7a-96b9-4335-a1f8-80e6eae459f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-7d7c-7458-8326-d6f2c5e25548.webp",
      "image_media": {
        "alt_text": "Aerial view of a large apartment complex with multiple buildings, a pool, and parking areas.",
        "public_id": "019e84a4-7d7c-7458-8326-d6f2c5e25548",
        "storage_key": "property/6737460151191768/019e84a4-7d7c-7458-8326-d6f2c5e25548.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Spacious apartment complex featuring modern buildings, a resort-style pool, and ample parking, offering a comfortable and convenient living experience.",
      "link": "",
      "alt_text": "Aerial view of a large apartment complex with multiple buildings, a pool, and parking areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2d22a046-ed3f-4b41-a1db-8fc57813d365",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-7493-70d0-9855-1cc742578840.webp",
      "image_media": {
        "alt_text": "Luxurious apartment community lounge with comfortable seating and modern decor.",
        "public_id": "019e84a4-7493-70d0-9855-1cc742578840",
        "storage_key": "property/6737460151191768/019e84a4-7493-70d0-9855-1cc742578840.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Step into the stylish and inviting lounge area of our apartment community, featuring plush seating, contemporary design, and a welcoming atmosphere for residents.",
      "link": "",
      "alt_text": "Luxurious apartment community lounge with comfortable seating and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_83138478-14e1-4533-a020-1ebb3a518ec8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-778a-7378-8b33-f90a1d85984c.webp",
      "image_media": {
        "alt_text": "Cabana seating area overlooking a swimming pool and apartment buildings.",
        "public_id": "019e84a4-778a-7378-8b33-f90a1d85984c",
        "storage_key": "property/6737460151191768/019e84a4-778a-7378-8b33-f90a1d85984c.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy resort-style living with this beautiful outdoor swimming pool and cabana area. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Cabana seating area overlooking a swimming pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f541b7f7-3a79-40c7-ac14-afda9010690f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-565e-7278-b62b-596de20bccc0.webp",
      "image_media": {
        "alt_text": "Outdoor dog park with a green tunnel, benches, and apartment buildings in the background.",
        "public_id": "019e84a4-565e-7278-b62b-596de20bccc0",
        "storage_key": "property/6737460151191768/019e84a4-565e-7278-b62b-596de20bccc0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, complete with agility equipment and plenty of room for your furry friends to play. Features benches and a shaded pavilion for owners.",
      "link": "",
      "alt_text": "Outdoor dog park with a green tunnel, benches, and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_10148209-a911-49d6-bc5d-6a0617bc51bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-538e-773b-af38-ab0900ffb352.webp",
      "image_media": {
        "alt_text": "Modern lounge area with black leather sofas, a unique coffee table, and bar seating with pendant lights.",
        "public_id": "019e84a4-538e-773b-af38-ab0900ffb352",
        "storage_key": "property/6737460151191768/019e84a4-538e-773b-af38-ab0900ffb352.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, a modern kitchen area, and a chic bar perfect for socializing.",
      "link": "",
      "alt_text": "Modern lounge area with black leather sofas, a unique coffee table, and bar seating with pendant lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7506264c-30aa-4b13-9b64-accad5ad41ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-b755-774a-9350-88793e95e0c9.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with red brick buildings, carports, and a swimming pool.",
        "public_id": "019e84a4-b755-774a-9350-88793e95e0c9",
        "storage_key": "property/6737460151191768/019e84a4-b755-774a-9350-88793e95e0c9.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing a modern multifamily apartment complex. The image highlights the property's red brick architecture, ample carports, well-maintained grounds, and a central swimming pool area, offering a comprehensive look at the community's amenities and layout.",
      "link": "",
      "alt_text": "Aerial view of a multifamily apartment complex with red brick buildings, carports, and a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0f04d271-2b75-4e2b-8977-f112476f8fab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e84a4-4fea-74df-b6e9-3eb3989166eb.webp",
      "image_media": {
        "alt_text": "A brightly lit playground with a green slide and tunnel, artificial turf, and apartment buildings in the background.",
        "public_id": "019e84a4-4fea-74df-b6e9-3eb3989166eb",
        "storage_key": "property/6737460151191768/019e84a4-4fea-74df-b6e9-3eb3989166eb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our state-of-the-art playground, featuring a vibrant slide and tunnel, perfect for children's entertainment and family gatherings.",
      "link": "",
      "alt_text": "A brightly lit playground with a green slide and tunnel, artificial turf, and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_7aed61ac-0ebb-48e8-9394-6a3d92f7a0c2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Yan Tea Cafe",
      "poi_type": "Restaurants",
      "poi_address": "23119 Colonial Pkwy Ste B-5, Katy, TX 77449, USA",
      "poi_short_description": "Tearoom cafe specializing in crème fruit & bubble teas alongside Japanese sweet baked goods.",
      "poi_long_description": "Tearoom cafe specializing in crème fruit & bubble teas alongside Japanese sweet baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-84b5-762c-ad4b-896b93e7a6e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-84b5-762c-ad4b-896b93e7a6e8",
        "storage_key": "property/6737460151191768/019e1e29-84b5-762c-ad4b-896b93e7a6e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://yanteacafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6444777982252166741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yan-tea-cafe",
      "poi_latitude": "29.7931028",
      "poi_longitude": "-95.7742301",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 832-437-0088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTap5N-EnQYYRVS5m0G1zcFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_9795364c-c96d-49e0-a05a-9748c6f42516",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Jia Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "23119 Colonial Pkwy B11, Katy, TX 77449, USA",
      "poi_short_description": "Asian dishes such as noodle soup and dumplings in a clean-lined space, plus seafood options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-7c36-7096-bc26-62872cae7571.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-7c36-7096-bc26-62872cae7571",
        "storage_key": "property/6737460151191768/019e1e29-7c36-7096-bc26-62872cae7571.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jia-kitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12983092642494455463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jia-kitchen",
      "poi_latitude": "29.7925637",
      "poi_longitude": "-95.7747054",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-769-9388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT9Cnr24nQYYRp57ekfg1LbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_da54a153-2271-4fbe-b7c4-d6bdde0a0452",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Zake Sushi & Ramen",
      "poi_type": "Restaurants",
      "poi_address": "23119 Colonial Pkwy, Katy, TX 77449, USA",
      "poi_short_description": "Japanese restaurant offering sushi, ramen, and other classic dishes, plus a variety of sake.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-7cd6-7724-b426-b044a6acd13a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-7cd6-7724-b426-b044a6acd13a",
        "storage_key": "property/6737460151191768/019e1e29-7cd6-7724-b426-b044a6acd13a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://zakesushi.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=4668376775713036316&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zake-sushi--ramen",
      "poi_latitude": "29.7931008",
      "poi_longitude": "-95.7737338",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 832-913-6696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPVLtwZsnQYYRHBgPgvFnyUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_70bfe267-32cf-4de5-8548-8930f2fc8426",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Fuji Tea",
      "poi_type": "Restaurants",
      "poi_address": "23119 Colonial Pkwy c5, Katy, TX 77449, USA",
      "poi_short_description": "Trendy teahouse originating from Taiwan serving bubble teas and coffees in a modern space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-851b-769b-abee-14109d265650.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-851b-769b-abee-14109d265650",
        "storage_key": "property/6737460151191768/019e1e29-851b-769b-abee-14109d265650.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.fujitea.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7047313457555092959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fuji-tea",
      "poi_latitude": "29.7926668",
      "poi_longitude": "-95.772991",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-665-3959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c316-72aa-bb00-92f3780ae0cc",
        "storage_key": "property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIbOZViInQYYR37VmWkAWzWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tea_house"
    },
    {
      "id": "custom_17d9b115-9588-44b6-9d3b-1fcbc5b87fbd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Tan Tan Wok",
      "poi_type": "Restaurants",
      "poi_address": "23119 Colonial Pkwy Suite B12, Katy, TX 77449, USA",
      "poi_short_description": "Familiar Chinese and Vietnamese staples, plus some Thai eats, amid a clean, casual vibe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-8005-76d2-83df-3ed74e555bbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-8005-76d2-83df-3ed74e555bbf",
        "storage_key": "property/6737460151191768/019e1e29-8005-76d2-83df-3ed74e555bbf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tantanwok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11733591179626801707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tan-tan-wok",
      "poi_latitude": "29.7924488",
      "poi_longitude": "-95.774855",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-769-9966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ-taB4snQYYRK-pPuQIX1qI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_c9794099-2c4c-4719-a4a5-9e0f2d2e3a20",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Yummy Pho & Bo Ne",
      "poi_type": "Restaurants",
      "poi_address": "23119 Colonial Pkwy #A11, Katy, TX 77449, USA",
      "poi_short_description": "Strip-mall spot serving up pho & other classic Vietnamese dishes in a low-key dining room.",
      "poi_long_description": "Strip-mall spot serving up pho & other classic Vietnamese dishes in a low-key dining room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-7c77-71b9-8b98-274f4aad5520.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-7c77-71b9-8b98-274f4aad5520",
        "storage_key": "property/6737460151191768/019e1e29-7c77-71b9-8b98-274f4aad5520.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://yummyphokaty.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8686345239062297844&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yummy-pho--bo-ne",
      "poi_latitude": "29.7931372",
      "poi_longitude": "-95.7736869",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 832-437-0486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95V-oP0mQYYR9Ly2AvkYjHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_dc77c95c-7933-4d3e-9b13-a905c7543766",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Sul Bing Su",
      "poi_type": "Restaurants",
      "poi_address": "23119 Colonial Pkwy Ste B16, Katy, TX 77449, USA",
      "poi_short_description": "Korean-style cake shop serving shaved ice, taiyaki fish-shaped pastries, donuts and soft ice cream, plus hot dogs and other sweets.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-7f91-75be-9752-409748cf06dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-7f91-75be-9752-409748cf06dd",
        "storage_key": "property/6737460151191768/019e1e29-7f91-75be-9752-409748cf06dd.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/SULBINGSUTX/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6513922121117195110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sul-bing-su",
      "poi_latitude": "29.792262",
      "poi_longitude": "-95.7750119",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 832-930-7802",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c31a-7140-ac55-abba18bf58eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c31a-7140-ac55-abba18bf58eb",
        "storage_key": "property/6737460151191768/019e1e27-c31a-7140-ac55-abba18bf58eb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn6gCYD8nQYYRZtu_K6gZZlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dessert_shop"
    },
    {
      "id": "custom_8b5b553b-4b69-4769-9f4c-d144cc9b8925",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Sweet Me Up",
      "poi_type": "Restaurants",
      "poi_address": "23119 Colonial Pkwy B-20, Katy, TX 77449, USA",
      "poi_short_description": "Contemporary, airy counter-service pit stop for standard dim sum & Asian dishes.",
      "poi_long_description": "Contemporary, airy counter-service pit stop for standard dim sum & Asian dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-80a6-772e-ab47-dae8347241e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-80a6-772e-ab47-dae8347241e1",
        "storage_key": "property/6737460151191768/019e1e29-80a6-772e-ab47-dae8347241e1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.facebook.com/sweetmeupcafe",
      "poi_directions_map_url": "https://maps.google.com/?cid=7002568067197088141&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweet-me-up",
      "poi_latitude": "29.7919881",
      "poi_longitude": "-95.7750554",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 832-990-8853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3_z54PwmQYYRjbHGUI4eLmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_f4413e9c-c3c3-48b0-8d60-8a431c9736e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Square Root Poké",
      "poi_type": "Restaurants",
      "poi_address": "23119 Colonial Pkwy Suite #C-9, Katy, TX 77449, USA",
      "poi_short_description": "Strip-mall cafe serving house & build-your-own poke bowls plus some cooked fare in hip, modern digs.",
      "poi_long_description": "Strip-mall cafe serving house & build-your-own poke bowls plus some cooked fare in hip, modern digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-836e-731a-bd88-1c2cd49ce350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-836e-731a-bd88-1c2cd49ce350",
        "storage_key": "property/6737460151191768/019e1e29-836e-731a-bd88-1c2cd49ce350.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.squarerootpokekaty.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13993664243383805410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "square-root-pok",
      "poi_latitude": "29.7928192",
      "poi_longitude": "-95.7733668",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 832-437-7651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVBf0mQYYR4iX63Hx7M8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hawaiian_restaurant"
    },
    {
      "id": "custom_22118534-4e66-4637-89ea-a686f14a7fd8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Phat Eatery - Katy",
      "poi_type": "Restaurants",
      "poi_address": "23119 Colonial Pkwy suite b-2, Katy, TX 77449, USA",
      "poi_short_description": "Colorful & bustling cafe dishing up a diverse selection of Malaysian street food specialties.",
      "poi_long_description": "Colorful & bustling cafe dishing up a diverse selection of Malaysian street food specialties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-7eb4-7325-b7ce-8108cdd0ad70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-7eb4-7325-b7ce-8108cdd0ad70",
        "storage_key": "property/6737460151191768/019e1e29-7eb4-7325-b7ce-8108cdd0ad70.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.phateatery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3092355087083409301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phat-eatery---katy",
      "poi_latitude": "29.7934034",
      "poi_longitude": "-95.7742506",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 832-412-2927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDQ2vv9knQYYRlY_6VJFA6io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "malaysian_restaurant"
    },
    {
      "id": "custom_d5c0f73f-9d00-4a95-9c19-ebebea35861b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Yummy Seafood & Oyster Bar",
      "poi_type": "Restaurants",
      "poi_address": "23119 Colonial Pkwy Suite A14, Katy, TX 77449, USA",
      "poi_short_description": "Louisiana-inspired eatery for boiled Cajun seafood (crawfish, shrimp, crab), oysters and fried snacks, plus beer and cocktails..",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-872d-716b-a841-136703834d5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-872d-716b-a841-136703834d5d",
        "storage_key": "property/6737460151191768/019e1e29-872d-716b-a841-136703834d5d.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://katy.yummysob.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9300653579980640107&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yummy-seafood--oyster-bar",
      "poi_latitude": "29.7931154",
      "poi_longitude": "-95.7733057",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 281-665-7623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1S1-f4QnQYYRaw-2bSePEoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_0f3bcc34-8798-463c-8b57-0488c27ce613",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Tropical Diner",
      "poi_type": "Restaurants",
      "poi_address": "3111 N Fry Rd, Katy, TX 77449, USA",
      "poi_short_description": "No-frills establishment furnishing jerk chicken & other traditional Jamaican & Caribbean eats.",
      "poi_long_description": "No-frills establishment furnishing jerk chicken & other traditional Jamaican & Caribbean eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-8905-7697-b45c-2501e51741d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-8905-7697-b45c-2501e51741d6",
        "storage_key": "property/6737460151191768/019e1e29-8905-7697-b45c-2501e51741d6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jamaicanfoodhouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2498092228843827398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tropical-diner",
      "poi_latitude": "29.8168878",
      "poi_longitude": "-95.7215739",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-579-9060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf0arbnDYQIYRxnBmjKUBqyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_94991e2b-3bbe-4f38-a59c-f1f3eb50f468",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Maika’i Hawaiian BBQ",
      "poi_type": "Restaurants",
      "poi_address": "1321 N Westgreen Blvd ste 200, Katy, TX 77494, USA",
      "poi_short_description": "Casual Hawaiian eatery specializing in BBQ chicken, katsu, and spam musubi, plus fried options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-8d33-772e-aa31-2f5b95989a8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-8d33-772e-aa31-2f5b95989a8e",
        "storage_key": "property/6737460151191768/019e1e29-8d33-772e-aa31-2f5b95989a8e.webp",
        "width": 1280,
        "height": 1204
      },
      "poi_business_url": "https://maikaihawaiianbbqtexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1799820089717211982&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maikai-hawaiian-bbq",
      "poi_latitude": "29.7874131",
      "poi_longitude": "-95.7363678",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 832-913-6466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9bY4p-olQYYRTsM089U--hg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e4a7aa45-971b-438b-9a6b-eb6826d95d0c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Whiskey Cake Kitchen & Bar",
      "poi_type": "Restaurants",
      "poi_address": "23139 Grand Cir Blvd, Katy, TX 77449, USA",
      "poi_short_description": "Relaxed outlet with rocking chairs & a porch plating freshly prepped & mesquite wood grilled dishes.",
      "poi_long_description": "Relaxed outlet with rocking chairs & a porch plating freshly prepped & mesquite wood grilled dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-8b56-73e8-95cd-bcbf637aafb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-8b56-73e8-95cd-bcbf637aafb5",
        "storage_key": "property/6737460151191768/019e1e29-8b56-73e8-95cd-bcbf637aafb5.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.whiskeycake.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7862470216402617401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whiskey-cake-kitchen--bar",
      "poi_latitude": "29.7867949",
      "poi_longitude": "-95.7723303",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 832-430-2253",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ69DLeeImQYYROUTEMQEbHW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_47a7c2cf-5015-4802-b235-12468fdca8ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Renzi's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "3349 W Grand Pkwy N Suite #102, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-8bb6-72ff-9063-21377d954d23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-8bb6-72ff-9063-21377d954d23",
        "storage_key": "property/6737460151191768/019e1e29-8bb6-72ff-9063-21377d954d23.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.renzispizzas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17622662809331395512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renzis-pizza",
      "poi_latitude": "29.8230028",
      "poi_longitude": "-95.7678246",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 346-387-9544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfxbLd6gnQYYRuGuvynRGkPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_8ef292ce-2b7f-4480-ad6e-3157b1526310",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "22850 Morton Ranch Rd, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-8942-713b-bb0f-0112ceb27356.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-8942-713b-bb0f-0112ceb27356",
        "storage_key": "property/6737460151191768/019e1e29-8942-713b-bb0f-0112ceb27356.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/4512-katy-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14647586667579804552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "29.8186406",
      "poi_longitude": "-95.767742",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 346-307-8163",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c31a-7140-ac55-abba18bf58eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c31a-7140-ac55-abba18bf58eb",
        "storage_key": "property/6737460151191768/019e1e27-c31a-7140-ac55-abba18bf58eb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJeSDQYronQYYRiIvXyXeuRss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_45e90683-e6eb-4fd1-9cdc-34b2a65d4b5e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "2700 W Grand Pkwy N, Katy, TX 77449, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-8c04-75ce-be52-d8b6cb645d69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-8c04-75ce-be52-d8b6cb645d69",
        "storage_key": "property/6737460151191768/019e1e29-8c04-75ce-be52-d8b6cb645d69.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/katy/morton/034/00122?cid=loc_03400122_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6830391818398740157&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "29.8125916",
      "poi_longitude": "-95.7701499",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 346-307-3084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c3c3-71ee-b590-3b59d2b5afa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c3c3-71ee-b590-3b59d2b5afa6",
        "storage_key": "property/6737460151191768/019e1e27-c3c3-71ee-b590-3b59d2b5afa6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_1WXb60nQYYRvS5kfCttyl4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_fec9a23e-d4bc-44aa-a99d-94ea5cb35a7d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "24924 Morton Ranch Rd, Katy, TX 77493, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-8c5f-736d-a689-ee4895acba8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e27-8c5f-736d-a689-ee4895acba8d",
        "storage_key": "property/6737460151191768/019e1e27-8c5f-736d-a689-ee4895acba8d.webp",
        "width": 1280,
        "height": 749
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/katy/katy-park-h-e-b-797?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores&utm_content=katy-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6908448740309966722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "29.8190607",
      "poi_longitude": "-95.8061995",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-547-1365",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c3c3-71ee-b590-3b59d2b5afa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c3c3-71ee-b590-3b59d2b5afa6",
        "storage_key": "property/6737460151191768/019e1e27-c3c3-71ee-b590-3b59d2b5afa6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9yO6MwAnQYYRgp8r24a9318",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4c94fc88-e243-4dc8-a547-a21a8dcd11f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "El Rancho Supermercado",
      "poi_type": "Shopping & Retail",
      "poi_address": "3050 N Fry Rd, Katy, TX 77449, USA",
      "poi_short_description": "Chain grocery option featuring a bakery, a meat market and made-to-order juices.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-8fac-710e-9b14-87e8a1a4746c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-8fac-710e-9b14-87e8a1a4746c",
        "storage_key": "property/6737460151191768/019e1e29-8fac-710e-9b14-87e8a1a4746c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://elranchoinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17469381450491818128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-rancho-supermercado",
      "poi_latitude": "29.8134273",
      "poi_longitude": "-95.71923",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 832-321-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c3c3-71ee-b590-3b59d2b5afa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c3c3-71ee-b590-3b59d2b5afa6",
        "storage_key": "property/6737460151191768/019e1e27-c3c3-71ee-b590-3b59d2b5afa6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2YNcWzZQIYRkPBcWt-1b_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_9c466217-087f-48f0-ba0c-ca149228adce",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "3103 N Fry Rd, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-8cce-755a-ad10-41257999552f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-8cce-755a-ad10-41257999552f",
        "storage_key": "property/6737460151191768/019e1e29-8cce-755a-ad10-41257999552f.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/katy-tx-pharmacies/3103-n-fry-rd-katy-tx-77449/storeid=3702?WT.mc_id=LS_GOOGLE_RX_3702",
      "poi_directions_map_url": "https://maps.google.com/?cid=1317090083174624296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.8152719",
      "poi_longitude": "-95.7213065",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-646-2964",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-ca28-71bd-9bee-a293b7457cf9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e29-ca28-71bd-9bee-a293b7457cf9",
        "storage_key": "property/6737460151191768/019e1e29-ca28-71bd-9bee-a293b7457cf9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ11cHm3rYQIYRKCzQ0HM-RxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_ff66d4aa-f70f-4b81-ad10-f93c2372e315",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "3120 N Fry Rd, Katy, TX 77449, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-93d0-775c-9311-85b14d1c59d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-93d0-775c-9311-85b14d1c59d1",
        "storage_key": "property/6737460151191768/019e1e29-93d0-775c-9311-85b14d1c59d1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3120+n+fry+rd-katy-tx-77449/id=7019",
      "poi_directions_map_url": "https://maps.google.com/?cid=11826360262031403510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.8158013",
      "poi_longitude": "-95.7198567",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-829-5080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c316-72aa-bb00-92f3780ae0cc",
        "storage_key": "property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO0VTpnrYQIYR9mkt5P-rH6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_d1b9a189-ba4c-448b-961a-9d1006410d85",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "H Mart Katy",
      "poi_type": "Shopping & Retail",
      "poi_address": "23119 Colonial Pkwy bldg b, Katy, TX 77449, USA",
      "poi_short_description": "Asian grocery store chain supplying imported packaged foods & housewares plus ready-to-serve meals.",
      "poi_long_description": "Asian grocery store chain supplying imported packaged foods & housewares plus ready-to-serve meals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-9057-7208-a2a8-299f1345858c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e27-9057-7208-a2a8-299f1345858c",
        "storage_key": "property/6737460151191768/019e1e27-9057-7208-a2a8-299f1345858c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.hmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7195472934661369441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-mart-katy",
      "poi_latitude": "29.792778",
      "poi_longitude": "-95.7744413",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 832-234-0340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c3c3-71ee-b590-3b59d2b5afa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c3c3-71ee-b590-3b59d2b5afa6",
        "storage_key": "property/6737460151191768/019e1e27-c3c3-71ee-b590-3b59d2b5afa6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv3WI_vwmQYYRYa5txYJ022M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_817595e1-4df0-4b47-904e-2ac7a47cd56c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "23645 Katy Fwy, Katy, TX 77494, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-9121-720c-a840-7adc5bc02c6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-9121-720c-a840-7adc5bc02c6f",
        "storage_key": "property/6737460151191768/019e1e29-9121-720c-a840-7adc5bc02c6f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/katy-TX-1167.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13469528817186269628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "29.782855",
      "poi_longitude": "-95.781095",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-347-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c31a-7140-ac55-abba18bf58eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c31a-7140-ac55-abba18bf58eb",
        "storage_key": "property/6737460151191768/019e1e27-c31a-7140-ac55-abba18bf58eb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJSYGIkuYmQYYRvGlGOBhh7bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_71752b7d-6860-4c4c-87dc-8d145008c2e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Diane Winborn Elementary School",
      "poi_type": "Education",
      "poi_address": "22555 Prince George St, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-9130-72aa-84c7-70352d075556.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-9130-72aa-84c7-70352d075556",
        "storage_key": "property/6737460151191768/019e1e29-9130-72aa-84c7-70352d075556.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.katyisd.org/DWE",
      "poi_directions_map_url": "https://maps.google.com/?cid=15348917788022086559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "diane-winborn-elementary-school",
      "poi_latitude": "29.7985673",
      "poi_longitude": "-95.7641306",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-237-6650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c385-7450-a363-d30a764248b7",
        "storage_key": "property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS8dJYAYnQYYRnxu7-WdPAtU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_4e7d8f73-d38c-4f3e-917b-c5afaa2424c3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Morton Ranch Elementary",
      "poi_type": "Education",
      "poi_address": "2502 N Mason Rd, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-91fa-73fa-9451-9ec5c3bd6575.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-91fa-73fa-9451-9ec5c3bd6575",
        "storage_key": "property/6737460151191768/019e1e29-91fa-73fa-9451-9ec5c3bd6575.webp",
        "width": 1280,
        "height": 631
      },
      "poi_business_url": "https://www.katyisd.org/MRE",
      "poi_directions_map_url": "https://maps.google.com/?cid=8193269291854945163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morton-ranch-elementary",
      "poi_latitude": "29.807661",
      "poi_longitude": "-95.7462539",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-234-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c385-7450-a363-d30a764248b7",
        "storage_key": "property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD9s-lL0nQYYRi1sh2gJXtHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_0dd60cf5-5845-4d4f-88a1-38171e2b4773",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Morton Ranch Junior High",
      "poi_type": "Education",
      "poi_address": "2498 N Mason Rd, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-92a0-7083-b5ff-b2e6eba8f5fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-92a0-7083-b5ff-b2e6eba8f5fc",
        "storage_key": "property/6737460151191768/019e1e29-92a0-7083-b5ff-b2e6eba8f5fc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.katyisd.org/MRJH",
      "poi_directions_map_url": "https://maps.google.com/?cid=15777068162238114940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morton-ranch-junior-high",
      "poi_latitude": "29.808528",
      "poi_longitude": "-95.7444143",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-237-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c385-7450-a363-d30a764248b7",
        "storage_key": "property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYcQ-lL0nQYYRfOxTL-dn89o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_08623d37-ce60-4563-9956-a4b7d0884a65",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Morton Ranch High School",
      "poi_type": "Education",
      "poi_address": "21000 Franz Rd, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-9582-76b9-ad6d-1362828f727b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-9582-76b9-ad6d-1362828f727b",
        "storage_key": "property/6737460151191768/019e1e29-9582-76b9-ad6d-1362828f727b.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.katyisd.org/MRHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=3417080932918947439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morton-ranch-high-school",
      "poi_latitude": "29.8038076",
      "poi_longitude": "-95.744939",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-237-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c385-7450-a363-d30a764248b7",
        "storage_key": "property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL6e1zgG8QIYRb-5kBwHpay8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_96773f6c-0aad-4c8a-887f-a9a12ddac998",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Franz Elementary School",
      "poi_type": "Education",
      "poi_address": "2751 N Westgreen Blvd, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-9a33-710c-8c9d-b58315973231.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-9a33-710c-8c9d-b58315973231",
        "storage_key": "property/6737460151191768/019e1e29-9a33-710c-8c9d-b58315973231.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fes.katyisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11677492798711944255&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "franz-elementary-school",
      "poi_latitude": "29.8064554",
      "poi_longitude": "-95.7398628",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-237-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c385-7450-a363-d30a764248b7",
        "storage_key": "property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3XLTHoMnQYYRP1RoltTJDqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f5f4c67b-e89b-410d-8145-e81fb4150eca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Lone Star College-Cypress Center",
      "poi_type": "Education",
      "poi_address": "19710 Clay Rd, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-99ba-77ec-a244-18223811ae10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-99ba-77ec-a244-18223811ae10",
        "storage_key": "property/6737460151191768/019e1e29-99ba-77ec-a244-18223811ae10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lonestar.edu/cypresscenter.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=12791345367230527369&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lone-star-college-cypress-center",
      "poi_latitude": "29.8321086",
      "poi_longitude": "-95.7151426",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 832-920-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c385-7450-a363-d30a764248b7",
        "storage_key": "property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO5hc6RPYQIYRiTcdDdf8g7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5db08dcd-0f0f-456a-a8ba-c3537b44535e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "British International School of Houston",
      "poi_type": "Education",
      "poi_address": "2203 N Westgreen Blvd, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-9a0d-709c-8564-91890f1cabef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-9a0d-709c-8564-91890f1cabef",
        "storage_key": "property/6737460151191768/019e1e29-9a0d-709c-8564-91890f1cabef.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.nordangliaeducation.com/bis-houston?utm_source=google&utm_medium=organic&utm_campaign=Yext_GBM_AM010_10700937&y_source=1_MTA3MDA5MzctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15064192478506077171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "british-international-school-of-houston",
      "poi_latitude": "29.7994057",
      "poi_longitude": "-95.7370579",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-290-9025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c385-7450-a363-d30a764248b7",
        "storage_key": "property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7ybf_mjGQIYR80t35T7DDtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4f433a94-3505-4c8f-a411-e8d2f651c55f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Montessori Reggio Academy® of Katy",
      "poi_type": "Education",
      "poi_address": "20318 Franz Rd, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-9ee3-70ae-a459-a250defd8c0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-9ee3-70ae-a459-a250defd8c0e",
        "storage_key": "property/6737460151191768/019e1e29-9ee3-70ae-a459-a250defd8c0e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.montessorireggioacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3675362057132949820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montessori-reggio-academy-of-katy",
      "poi_latitude": "29.8016913",
      "poi_longitude": "-95.737499",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 346-271-8805",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c385-7450-a363-d30a764248b7",
        "storage_key": "property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG8tCk0UnQYYRPMFbbFGCATM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_780df152-b8a2-4245-a086-f26197095b50",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Kids 'R' Kids Learning Academy of Mason and Clay",
      "poi_type": "Education",
      "poi_address": "3902 N Mason Rd, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-9e02-737f-83c9-f59ab47c220b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-9e02-737f-83c9-f59ab47c220b",
        "storage_key": "property/6737460151191768/019e1e29-9e02-737f-83c9-f59ab47c220b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kidsrkids.com/mason-and-clay",
      "poi_directions_map_url": "https://maps.google.com/?cid=12093456007675265306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kids-r-kids-learning-academy-of-mason-and-clay",
      "poi_latitude": "29.8305166",
      "poi_longitude": "-95.7537698",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-398-1740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c385-7450-a363-d30a764248b7",
        "storage_key": "property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD0MXoL8nQYYRGkFMRCqW1Kc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_ea87ac5d-9b04-4d57-881e-bfb243943c6e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "AMC Katy Mills 20",
      "poi_type": "Entertainment",
      "poi_address": "5000 Katy Mills Cir #131, Katy, TX 77494, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-9baa-759b-acdf-71613646ef76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-9baa-759b-acdf-71613646ef76",
        "storage_key": "property/6737460151191768/019e1e29-9baa-759b-acdf-71613646ef76.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/houston/amc-katy-mills-20?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15478905560829687672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-katy-mills-20",
      "poi_latitude": "29.7724542",
      "poi_longitude": "-95.8096915",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-644-4262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-ca17-720a-ad0c-d82cec2a0190.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e29-ca17-720a-ad0c-d82cec2a0190",
        "storage_key": "property/6737460151191768/019e1e29-ca17-720a-ad0c-d82cec2a0190.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJX7OEjKEmQYYReHcSyZge0NY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_9df5d337-4aff-4b5a-8f11-15959321266b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Andretti Indoor Karting & Games Katy",
      "poi_type": "Entertainment",
      "poi_address": "1230 Grand W Blvd, Katy, TX 77449, USA",
      "poi_short_description": "Indoor sports hub with a karting track, video arcades & VR games, plus laser tag & food trucks.",
      "poi_long_description": "Indoor sports hub with a karting track, video arcades & VR games, plus laser tag & food trucks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-9c28-751d-9ae3-e26c87b14ec6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-9c28-751d-9ae3-e26c87b14ec6",
        "storage_key": "property/6737460151191768/019e1e29-9c28-751d-9ae3-e26c87b14ec6.webp",
        "width": 750,
        "height": 422
      },
      "poi_business_url": "https://andrettikarting.com/katy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10312037114075563588&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andretti-indoor-karting--games-katy",
      "poi_latitude": "29.7892259",
      "poi_longitude": "-95.7695533",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 832-974-2201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c316-72aa-bb00-92f3780ae0cc",
        "storage_key": "property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnT6dx6MnQYYRREYepx63G48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_9677b261-b62c-4d86-a4d1-0e4932133e9d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "PopStroke",
      "poi_type": "Entertainment",
      "poi_address": "23110 Grand Cir Blvd, Katy, TX 77449, USA",
      "poi_short_description": "Laid-back putt-putt spot featuring two 18-hole courses, a playground and a bar for cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-9f2e-71fb-9335-8e336639e1e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-9f2e-71fb-9335-8e336639e1e9",
        "storage_key": "property/6737460151191768/019e1e29-9f2e-71fb-9335-8e336639e1e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://popstroke.com/venues/houston-katy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3932178865936945402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "popstroke",
      "poi_latitude": "29.78781829999999",
      "poi_longitude": "-95.7713859",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-715-0480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c316-72aa-bb00-92f3780ae0cc",
        "storage_key": "property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrwhxlRInQYYR-lB4UdjnkTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "miniature_golf_course"
    },
    {
      "id": "custom_5ba373f2-7d7e-42ee-8616-a438b102234c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "No Label Brewing Co.",
      "poi_type": "Entertainment",
      "poi_address": "5351 1st St, Katy, TX 77493, USA",
      "poi_short_description": "Weekly tours & tastings offered at a kid-friendly brewery in an old rice silo, plus a picnic area.",
      "poi_long_description": "Weekly tours & tastings offered at a kid-friendly brewery in an old rice silo, plus a picnic area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-a0d4-76aa-90f6-2fb1038a85cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-a0d4-76aa-90f6-2fb1038a85cf",
        "storage_key": "property/6737460151191768/019e1e29-a0d4-76aa-90f6-2fb1038a85cf.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://nolabelbrew.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2506964500717007828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "no-label-brewing-co",
      "poi_latitude": "29.7865238",
      "poi_longitude": "-95.81432",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-693-7545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c316-72aa-bb00-92f3780ae0cc",
        "storage_key": "property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr9NSvCckQYYR1HPAUe6GyiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_f2b957e3-0da8-481b-8971-6cab4341c44d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Katy Beer Garden",
      "poi_type": "Entertainment",
      "poi_address": "5345 E 3rd St, Katy, TX 77493, USA",
      "poi_short_description": "Beer-garden, known for its large selection of craft beers, offering burgers, cocktails, and wine, along with TVs and an onsite bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-a3e2-77bc-a941-6b48e21e4405.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-a3e2-77bc-a941-6b48e21e4405",
        "storage_key": "property/6737460151191768/019e1e29-a3e2-77bc-a941-6b48e21e4405.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.katybeergarden.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1949404992251458443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katy-beer-garden",
      "poi_latitude": "29.7878948",
      "poi_longitude": "-95.813159",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 346-395-8711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-ca29-734e-96fd-ab070115c32b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e29-ca29-734e-96fd-ab070115c32b",
        "storage_key": "property/6737460151191768/019e1e29-ca29-734e-96fd-ab070115c32b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFbxpzoMlQYYRi3OFFoOtDRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "beer_garden"
    },
    {
      "id": "custom_e959f11e-d526-4013-99af-917b63d7615c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Home Run Dugout",
      "poi_type": "Entertainment",
      "poi_address": "1220 Grand W Blvd, Katy, TX 77449, USA",
      "poi_short_description": "American restaurant and beer garden offering a menu of comfort food, live music, and a batting cage.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-9181-73a6-a28f-7582aeb2ff9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e27-9181-73a6-a28f-7582aeb2ff9f",
        "storage_key": "property/6737460151191768/019e1e27-9181-73a6-a28f-7582aeb2ff9f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.homerundugout.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8730370109309630214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "home-run-dugout",
      "poi_latitude": "29.78881669999999",
      "poi_longitude": "-95.7682123",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 833-384-6881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd1eDBfsnQYYRBrcW41uBKHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_0e04b69b-42c8-4d9e-9aa0-86b1454d2137",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Dig World",
      "poi_type": "Entertainment",
      "poi_address": "5000 Katy Mills Cir, Katy, TX 77494, USA",
      "poi_short_description": "Theme park next to Katy Mills Mall where kids can safely operate real construction equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-99a8-736e-a15f-e82e487980ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e27-99a8-736e-a15f-e82e487980ae",
        "storage_key": "property/6737460151191768/019e1e27-99a8-736e-a15f-e82e487980ae.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.digworldnation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2495034829060758170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dig-world",
      "poi_latitude": "29.778968",
      "poi_longitude": "-95.8094757",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 346-435-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c316-72aa-bb00-92f3780ae0cc",
        "storage_key": "property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb93T1gwnQYYRmtpkMPUkoCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_448b8ec4-aaaf-454e-b8bd-60737816c559",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Katy Heritage Park",
      "poi_type": "Entertainment",
      "poi_address": "5990 George Bush Dr, Katy, TX 77493, USA",
      "poi_short_description": "Park that's good for kids and includes attractions related to history.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-a3e3-7169-a654-cc0821e9a237.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-a3e3-7169-a654-cc0821e9a237",
        "storage_key": "property/6737460151191768/019e1e29-a3e3-7169-a654-cc0821e9a237.webp",
        "width": 607,
        "height": 1280
      },
      "poi_business_url": "http://cityofkaty.com/departments/parks/parks-and-facilities-2/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7458782409271609460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katy-heritage-park",
      "poi_latitude": "29.7910988",
      "poi_longitude": "-95.8260784",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-391-4840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c383-7698-a766-8a235a9dbfcf",
        "storage_key": "property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7xCiB7YlQYYRdAiRORXrgmc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8129be2f-8519-4588-bb5b-b4c8a0b392d0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Main Event Katy",
      "poi_type": "Entertainment",
      "poi_address": "24401 Katy Fwy, Katy, TX 77494, USA",
      "poi_short_description": "Laid-back chain, part of Katy Ranch Crossing, featuring bowling alleys and laser tag arenas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-8cd1-762b-a3ae-893a62b256c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e27-8cd1-762b-a3ae-893a62b256c4",
        "storage_key": "property/6737460151191768/019e1e27-8cd1-762b-a3ae-893a62b256c4.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/texas/katy",
      "poi_directions_map_url": "https://maps.google.com/?cid=441350998554445187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-event-katy",
      "poi_latitude": "29.7833217",
      "poi_longitude": "-95.7922727",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-394-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxXz5vO4mQYYRgwUaEmX-HwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7d8d8e78-ba56-4c37-9a1d-e47565c8f040",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Memorial Hermann Katy Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "23900 Katy Fwy, Katy, TX 77494, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-a3d7-74d8-8457-160987256f95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-a3d7-74d8-8457-160987256f95",
        "storage_key": "property/6737460151191768/019e1e29-a3d7-74d8-8457-160987256f95.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://memorialhermann.org/locations/katy?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=75134535897600095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-katy-hospital",
      "poi_latitude": "29.7875539",
      "poi_longitude": "-95.7864102",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-644-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c375-7738-a773-01d2685402b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c375-7738-a773-01d2685402b5",
        "storage_key": "property/6737460151191768/019e1e27-c375-7738-a773-01d2685402b5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqrogQYYRX1CKWnbuCgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_c08039bf-5e8e-492c-8853-6dbc1d601773",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - Morton Ranch",
      "poi_type": "Health and Wellness",
      "poi_address": "22915 Morton Ranch Rd, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-a7e3-76fa-812e-cdcc9917ccd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-a7e3-76fa-812e-cdcc9917ccd4",
        "storage_key": "property/6737460151191768/019e1e29-a7e3-76fa-812e-cdcc9917ccd4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://carenow.com/locations/houston/morton-ranch?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13585463473356142439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---morton-ranch",
      "poi_latitude": "29.8167039",
      "poi_longitude": "-95.7699369",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-505-6940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c316-72aa-bb00-92f3780ae0cc",
        "storage_key": "property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD3Lr3fInQYYRZ_dv1gxDibw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_95b500ff-2bf2-4a8f-b7c9-56eb849124a4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "22850 Morton Ranch Rd, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-a515-771d-bfbc-9c69d428707f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-a515-771d-bfbc-9c69d428707f",
        "storage_key": "property/6737460151191768/019e1e29-a515-771d-bfbc-9c69d428707f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/4512-katy-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13373772637681275563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "29.8189324",
      "poi_longitude": "-95.767574",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 346-307-8161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-ca28-71bd-9bee-a293b7457cf9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e29-ca28-71bd-9bee-a293b7457cf9",
        "storage_key": "property/6737460151191768/019e1e29-ca28-71bd-9bee-a293b7457cf9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeSDQYronQYYRq9LUT1svmbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_3371d638-c596-4b53-80e8-4c4c0d3e3f55",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Sam's Club Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "20424 Katy Fwy, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-a899-7748-8055-d37556e92d74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-a899-7748-8055-d37556e92d74",
        "storage_key": "property/6737460151191768/019e1e29-a899-7748-8055-d37556e92d74.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.samsclub.com/club/4764-katy-tx/pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=14855831169677995627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club-pharmacy",
      "poi_latitude": "29.7877033",
      "poi_longitude": "-95.7254997",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-578-5593",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-ca28-71bd-9bee-a293b7457cf9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e29-ca28-71bd-9bee-a293b7457cf9",
        "storage_key": "property/6737460151191768/019e1e29-ca28-71bd-9bee-a293b7457cf9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt1wBGZzYQIYRay7VP72DKs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_e0450a90-fbd3-4069-940f-721fb5051b2f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "F45 Training Morton Ranch",
      "poi_type": "Health and Wellness",
      "poi_address": "3445 W Grand Pkwy N, Katy, TX 77449, USA",
      "poi_short_description": "Group training facility offering 45-minute workouts that incorporate cardio and resistance exercises.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-a840-779b-a324-e7e6390a02bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-a840-779b-a324-e7e6390a02bf",
        "storage_key": "property/6737460151191768/019e1e29-a840-779b-a324-e7e6390a02bf.webp",
        "width": 948,
        "height": 533
      },
      "poi_business_url": "https://f45training.com/studio/mortonranch/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18419930864218795665&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "f45-training-morton-ranch",
      "poi_latitude": "29.816679",
      "poi_longitude": "-95.7721563",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-400-1441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c316-72aa-bb00-92f3780ae0cc",
        "storage_key": "property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWRKGNFAnQYYRke4DLYe9oP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6178fe43-6a37-4cf0-b8da-93f2f79b371e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "9Round Kickboxing Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "22720 Morton Ranch Rd #195, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-a883-71dc-9fc3-72708345e3ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-a883-71dc-9fc3-72708345e3ce",
        "storage_key": "property/6737460151191768/019e1e29-a883-71dc-9fc3-72708345e3ce.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.9round.com/locations/tx/katy/morton-ranch-rd",
      "poi_directions_map_url": "https://maps.google.com/?cid=16876496679130180354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "9round-kickboxing-fitness",
      "poi_latitude": "29.8183137",
      "poi_longitude": "-95.765739",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 832-608-1088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c316-72aa-bb00-92f3780ae0cc",
        "storage_key": "property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRQWEQbEnQYYRAiudbFBcNeo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ea1d8a66-104c-4ebf-8050-478a117dbd30",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "23211 Cinco Ranch Blvd, Katy, TX 77494, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-9db2-74bb-abe7-4fd1f7889301.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e27-9db2-74bb-abe7-4fd1f7889301",
        "storage_key": "property/6737460151191768/019e1e27-9db2-74bb-abe7-4fd1f7889301.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/tx/cinco-ranch.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=10149644263920371599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "29.7421448",
      "poi_longitude": "-95.7705562",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-644-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c316-72aa-bb00-92f3780ae0cc",
        "storage_key": "property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD6eeQ9ggQYYRjweO067H2ow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1e899e26-3034-409c-9d4a-9b446ccfc929",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "23144 Cinco Ranch Blvd, Katy, TX 77494, USA",
      "poi_short_description": "Heart-rate-based cardio workouts done in studios, with supportive coaching and personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-b39b-7222-9b4e-6552d7eeaa44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-b39b-7222-9b4e-6552d7eeaa44",
        "storage_key": "property/6737460151191768/019e1e29-b39b-7222-9b4e-6552d7eeaa44.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/katy-texas-0471?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=11242550141534785189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "29.7445429",
      "poi_longitude": "-95.7715489",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-727-0098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c316-72aa-bb00-92f3780ae0cc",
        "storage_key": "property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi0VG8dcgQYYRpc6yw8mPBZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3f32a7e9-4bd4-4caa-966a-75d5477700b0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "2717 Commercial Center Blvd Suite D-140, Katy, TX 77494, USA",
      "poi_short_description": "Ballet-inspired, low-impact fitness studio offering workout classes and apparel.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-ab12-7671-8f27-7efcb72c8b1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-ab12-7671-8f27-7efcb72c8b1a",
        "storage_key": "property/6737460151191768/019e1e29-ab12-7671-8f27-7efcb72c8b1a.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/katy-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=8058323289436271274&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "29.7403352",
      "poi_longitude": "-95.7748374",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-394-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c316-72aa-bb00-92f3780ae0cc",
        "storage_key": "property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG_vrRSYhQYYRqjIbQFbq1G8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_55d8b47a-5c82-4b81-a206-86ba26168964",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Central Green – Willow Fork Drainage District",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "23501 Cinco Ranch Blvd, Katy, TX 77494, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-acde-763b-9477-64be812e4d99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-acde-763b-9477-64be812e4d99",
        "storage_key": "property/6737460151191768/019e1e29-acde-763b-9477-64be812e4d99.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.centralgreenpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11114343322930341385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-green--willow-fork-drainage-district",
      "poi_latitude": "29.741424",
      "poi_longitude": "-95.7749041",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c383-7698-a766-8a235a9dbfcf",
        "storage_key": "property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7xwtPCYhQYYRCWb_ql0UPpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e956326f-f2df-4222-861e-8eda948c15e0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Willow Fork Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "23440 Cinco Ranch Blvd, Katy, TX 77494, USA",
      "poi_short_description": "Clean park featuring a playground and a butterfly garden, plus disc golf courses and picnic facilities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-ad6f-704c-9817-9edca96b8836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-ad6f-704c-9817-9edca96b8836",
        "storage_key": "property/6737460151191768/019e1e29-ad6f-704c-9817-9edca96b8836.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.willowforkdrainagedistrict.com/parks-trails/willow-fork-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6700229735960575357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willow-fork-park",
      "poi_latitude": "29.7506138",
      "poi_longitude": "-95.7767014",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c383-7698-a766-8a235a9dbfcf",
        "storage_key": "property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJe2VBWS0hQYYRfX1wDXL_-1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_51deda72-888d-4b7b-96b8-54c61b365a40",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Typhoon Texas Waterpark Houston",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "555 Katy Fort Bend Rd, Katy, TX 77494, USA",
      "poi_short_description": "Spacious, playful place with serpentine water slides & a lazy river for tubing, plus eateries.",
      "poi_long_description": "Spacious, playful place with serpentine water slides & a lazy river for tubing, plus eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-9330-746d-b204-48014c64a40a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e27-9330-746d-b204-48014c64a40a",
        "storage_key": "property/6737460151191768/019e1e27-9330-746d-b204-48014c64a40a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.typhoontexas.com/houston",
      "poi_directions_map_url": "https://maps.google.com/?cid=17151496343800091588&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "typhoon-texas-waterpark-houston",
      "poi_latitude": "29.7794714",
      "poi_longitude": "-95.8035959",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 832-426-7071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c316-72aa-bb00-92f3780ae0cc",
        "storage_key": "property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9qVvZcmQYYRxJOdWg1bBu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_24200598-a47b-473e-a52d-87bda108746c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "West Park Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "19205 Saums Rd, Katy, TX 77449, USA",
      "poi_short_description": "Family-friendly park with a playground and picnic tables, plus gym equipment for adults.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-b38a-7228-8754-7c0f797a80df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-b38a-7228-8754-7c0f797a80df",
        "storage_key": "property/6737460151191768/019e1e29-b38a-7228-8754-7c0f797a80df.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=276237804197954965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-park-preserve",
      "poi_latitude": "29.7998078",
      "poi_longitude": "-95.707769",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c383-7698-a766-8a235a9dbfcf",
        "storage_key": "property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMdcWDd7ZQIYRlcXAwNFk1QM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7e62b913-eee5-4c7e-b09b-bcd22c4345e1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Mayde Creek M.U.D - North Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "19226 Dayflower Dr, Katy, TX 77449, USA",
      "poi_short_description": "Peaceful, tree-scattered park with playgrounds, walking trails, and soccer fields.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-ae26-70fd-b7e6-12dc5da04640.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-ae26-70fd-b7e6-12dc5da04640",
        "storage_key": "property/6737460151191768/019e1e29-ae26-70fd-b7e6-12dc5da04640.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6584333665147950509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mayde-creek-mud---north-park",
      "poi_latitude": "29.8256501",
      "poi_longitude": "-95.7095821",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c383-7698-a766-8a235a9dbfcf",
        "storage_key": "property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ15QEmWrYQIYRrRXKSZVAYFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_14f452fb-6dd2-49cb-9f08-1fa7d8dc5c4e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "George Bush Park Bike Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16756 Westheimer Pkwy, Houston, TX 77082, USA",
      "poi_short_description": "Family-friendly park with scenic views and a long trail for walking, biking or running.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-b334-71cb-84cf-6e421c745ac9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-b334-71cb-84cf-6e421c745ac9",
        "storage_key": "property/6737460151191768/019e1e29-b334-71cb-84cf-6e421c745ac9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=469630594180836084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-park-bike-trail",
      "poi_latitude": "29.7236788",
      "poi_longitude": "-95.6875102",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c383-7698-a766-8a235a9dbfcf",
        "storage_key": "property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9-5hIuDeQIYR9OrNhYl2hAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_38b5e1d6-d2e2-4f42-914b-e1204415b727",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Bear Creek Pioneers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3535 War Memorial St, Houston, TX 77084, USA",
      "poi_short_description": "Wooded park known for abundant wildlife such as deer & ducks, with many trails, fields & activities.",
      "poi_long_description": "Wooded park known for abundant wildlife such as deer & ducks, with many trails, fields & activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-ba35-7579-af71-d6b4c597ed52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-ba35-7579-af71-d6b4c597ed52",
        "storage_key": "property/6737460151191768/019e1e29-ba35-7579-af71-d6b4c597ed52.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cp4.harriscountytx.gov/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=15025692315525117298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-creek-pioneers-park",
      "poi_latitude": "29.8252332",
      "poi_longitude": "-95.6270195",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c383-7698-a766-8a235a9dbfcf",
        "storage_key": "property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwGbtFzaQIYRcvUwK437hdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b9371d6a-19d8-4899-bc58-6ca764de53ba",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "City of Katy Off-Leash Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5414 Franz Rd, Katy, TX 77493, USA",
      "poi_short_description": "Covering 14 acres, this off-leash dog park has grassy fields & fountains & hosts annual events.",
      "poi_long_description": "Covering 14 acres, this off-leash dog park has grassy fields & fountains & hosts annual events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-b45f-720e-ad42-938a354d27af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-b45f-720e-ad42-938a354d27af",
        "storage_key": "property/6737460151191768/019e1e29-b45f-720e-ad42-938a354d27af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofkaty.com/Home/Components/FacilityDirectory/FacilityDirectory/6/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16026561768731967906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-katy-off-leash-dog-park",
      "poi_latitude": "29.8025755",
      "poi_longitude": "-95.8178528",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-391-4840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c383-7698-a766-8a235a9dbfcf",
        "storage_key": "property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJs2iBXNQlQYYRogEgLATJad4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_bf1d821d-1ff5-44f1-8862-3baa05aba6c9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Katy City Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5850 Franz Rd, Katy, TX 77493, USA",
      "poi_short_description": "Kid-friendly train-shaped park with slides, swings, tennis and basketball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-ad44-7029-b6c2-b707115f946d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e27-ad44-7029-b6c2-b707115f946d",
        "storage_key": "property/6737460151191768/019e1e27-ad44-7029-b6c2-b707115f946d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://cityofkaty.com/departments/parks/parks-and-facilities-2/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2260970080710474635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katy-city-park",
      "poi_latitude": "29.8028593",
      "poi_longitude": "-95.822828",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-391-4840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c383-7698-a766-8a235a9dbfcf",
        "storage_key": "property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bha9NIlQYYRi7uILE-UYB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_fa9fc0db-f1f0-4c70-989b-de182e4ce295",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Grand Parkway Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "1030 N Grand Pkwy, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-b973-7708-aa63-cf3c432ab0d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-b973-7708-aa63-cf3c432ab0d0",
        "storage_key": "property/6737460151191768/019e1e29-b973-7708-aa63-cf3c432ab0d0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4263015384683988709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grand-parkway-park--ride",
      "poi_latitude": "29.7876219",
      "poi_longitude": "-95.7760204",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-ca2a-7577-bc59-d5b5d6582c2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e29-ca2a-7577-bc59-d5b5d6582c2b",
        "storage_key": "property/6737460151191768/019e1e29-ca2a-7577-bc59-d5b5d6582c2b.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5-7oUuImQYYR5UYd7OdFKTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_c7ced8f8-2ece-4f07-a28b-ac8db181af35",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Kingsland Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "21669 Kingsland Blvd, Katy, TX 77450, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-baa3-76bc-a2a4-431f96f768e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-baa3-76bc-a2a4-431f96f768e5",
        "storage_key": "property/6737460151191768/019e1e29-baa3-76bc-a2a4-431f96f768e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16228968268042078283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kingsland-park--ride",
      "poi_latitude": "29.7747945",
      "poi_longitude": "-95.7449571",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-ca2a-7577-bc59-d5b5d6582c2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e29-ca2a-7577-bc59-d5b5d6582c2b",
        "storage_key": "property/6737460151191768/019e1e29-ca2a-7577-bc59-d5b5d6582c2b.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJfz3tbkQnQYYRSwi8r6fgOOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_673f76db-895a-490a-8904-1e7da8692f50",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Addicks Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "14230 Old Katy Rd, Houston, TX 77079, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-c082-7323-b286-a705ecad0f73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-c082-7323-b286-a705ecad0f73",
        "storage_key": "property/6737460151191768/019e1e29-c082-7323-b286-a705ecad0f73.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6059542481948761620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "addicks-park--ride",
      "poi_latitude": "29.7872884",
      "poi_longitude": "-95.6383329",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-ca2a-7577-bc59-d5b5d6582c2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e29-ca2a-7577-bc59-d5b5d6582c2b",
        "storage_key": "property/6737460151191768/019e1e29-ca2a-7577-bc59-d5b5d6582c2b.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xDFp93bQIYRFN7xUcjRF1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_f3a558b3-2422-479f-acbd-ad910d40c190",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Megabus Stop, Katy Mills Mall, Entrance 8",
      "poi_type": "Transportation & Transit",
      "poi_address": "Katy, TX 77494, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12012403836475570163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "megabus-stop-katy-mills-mall-entrance-8",
      "poi_latitude": "29.7721587",
      "poi_longitude": "-95.8088346",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c316-72aa-bb00-92f3780ae0cc",
        "storage_key": "property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaZUjSwAnQYYR83eqE6WhtKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_3f005351-40d1-4663-b5e5-762fd234048f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "West Houston Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "18000 Groschke Rd, Houston, TX 77084, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-afe4-714b-8e0a-906c689d1150.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e27-afe4-714b-8e0a-906c689d1150",
        "storage_key": "property/6737460151191768/019e1e27-afe4-714b-8e0a-906c689d1150.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.westhoustonairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1678447308733947609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-houston-airport",
      "poi_latitude": "29.8155138",
      "poi_longitude": "-95.6742614",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 281-492-2130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c368-7059-8ea8-7b835f8965e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c368-7059-8ea8-7b835f8965e8",
        "storage_key": "property/6737460151191768/019e1e27-c368-7059-8ea8-7b835f8965e8.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJQXjVdJjZQIYR2R5MO-8KSxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_3c8f7140-031e-4e8f-a30e-c513e4e511df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "George Bush Intercontinental Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2800 N Terminal Rd, Houston, TX 77032, USA",
      "poi_short_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_long_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-bc11-732e-9321-aad06c3ba3da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-bc11-732e-9321-aad06c3ba3da",
        "storage_key": "property/6737460151191768/019e1e29-bc11-732e-9321-aad06c3ba3da.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fly2houston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11296915713098302001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-intercontinental-airport",
      "poi_latitude": "29.9931058",
      "poi_longitude": "-95.3416255",
      "poi_miles_from_property": "40.2",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "3 hours 32 mins",
      "poi_driving_minutes": "47 mins",
      "poi_business_phone": "+1 281-230-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c368-7059-8ea8-7b835f8965e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c368-7059-8ea8-7b835f8965e8",
        "storage_key": "property/6737460151191768/019e1e27-c368-7059-8ea8-7b835f8965e8.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1VD2SO0QIYRMcLAyPy0xpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_1eb09590-9bba-41c6-b2f1-a11ed425f514",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Texas Children's Hospital West Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "18200 Katy Fwy, Houston, TX 77094, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-a5bb-77cd-82ef-434f90215543.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e27-a5bb-77cd-82ef-434f90215543",
        "storage_key": "property/6737460151191768/019e1e27-a5bb-77cd-82ef-434f90215543.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texaschildrens.org/locations/texas-childrens-hospital/west-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=7901152811411417951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-childrens-hospital-west-campus",
      "poi_latitude": "29.78780029999999",
      "poi_longitude": "-95.6928635",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 832-227-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c375-7738-a773-01d2685402b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c375-7738-a773-01d2685402b5",
        "storage_key": "property/6737460151191768/019e1e27-c375-7738-a773-01d2685402b5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJWxiVseHYQIYRX6tBsJ6Ipm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_07a03541-4d5d-4c0c-b506-a47e30ddec56",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Houston Methodist West Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "18500 Katy Fwy, Houston, TX 77094, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-a441-7013-820c-35173abb38d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e27-a441-7013-820c-35173abb38d2",
        "storage_key": "property/6737460151191768/019e1e27-a441-7013-820c-35173abb38d2.webp",
        "width": 1280,
        "height": 629
      },
      "poi_business_url": "https://www.houstonmethodist.org/locations/katy-west/?utm_source=gmb&utm_medium=organic&utm_campaign=all_location_gmb&utm_content=website-click",
      "poi_directions_map_url": "https://maps.google.com/?cid=9315019254502396471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-methodist-west-hospital",
      "poi_latitude": "29.7872016",
      "poi_longitude": "-95.6982542",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 832-522-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c375-7738-a773-01d2685402b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c375-7738-a773-01d2685402b5",
        "storage_key": "property/6737460151191768/019e1e27-c375-7738-a773-01d2685402b5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJqYUrEObYQIYRNxKKrKiYRYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_7a286acc-c111-450b-84d3-93b6769c313f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Oceans Behavioral Hospital Katy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "455 Park Grove Dr, Katy, TX 77450, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-c43e-727a-86c8-fbb8dee60507.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-c43e-727a-86c8-fbb8dee60507",
        "storage_key": "property/6737460151191768/019e1e29-c43e-727a-86c8-fbb8dee60507.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oceanshealthcare.com/location/oceans-behavioral-hospital-katy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12483793168590832870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oceans-behavioral-hospital-katy",
      "poi_latitude": "29.7779669",
      "poi_longitude": "-95.7486654",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-492-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c375-7738-a773-01d2685402b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c375-7738-a773-01d2685402b5",
        "storage_key": "property/6737460151191768/019e1e27-c375-7738-a773-01d2685402b5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJe8SkPUAnQYYR5gROr75XP60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d53e3b32-b54b-4d25-a01a-374c8714ea2b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "University of Houston-Victoria at Katy",
      "poi_type": "Education",
      "poi_address": "22400 Grand Cir Blvd Suite 206, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-c0a0-730d-8560-7902dc3ffef9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e29-c0a0-730d-8560-7902dc3ffef9",
        "storage_key": "property/6737460151191768/019e1e29-c0a0-730d-8560-7902dc3ffef9.webp",
        "width": 1280,
        "height": 823
      },
      "poi_business_url": "https://www.uhv.edu/katy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6797685187384304849&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-houston-victoria-at-katy",
      "poi_latitude": "29.7922992",
      "poi_longitude": "-95.7716686",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 281-396-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c385-7450-a363-d30a764248b7",
        "storage_key": "property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKXq-ClUmQYYR0eT5iKk6Vl4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_25b85737-4836-4043-8318-a2ed9f5916c6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Houston City College - Katy Campus",
      "poi_type": "Education",
      "poi_address": "22910 Colonial Pkwy, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-94f6-735f-b712-5f72165b4bdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e27-94f6-735f-b712-5f72165b4bdd",
        "storage_key": "property/6737460151191768/019e1e27-94f6-735f-b712-5f72165b4bdd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.hccs.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13237354447510935994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-city-college---katy-campus",
      "poi_latitude": "29.7945044",
      "poi_longitude": "-95.768164",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 713-718-5757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c385-7450-a363-d30a764248b7",
        "storage_key": "property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOzBdKpLYQIYRupnTSbyHtLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_aacb3478-3929-4c39-866d-e8e934b20fc0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Katy Independent School Dst",
      "poi_type": "Major Employers & Offices",
      "poi_address": "20370 Franz Rd, Katy, TX 77449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.katyisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1801241881879051754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katy-independent-school-dst",
      "poi_latitude": "29.8021699",
      "poi_longitude": "-95.7398243",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-675-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c385-7450-a363-d30a764248b7",
        "storage_key": "property/6737460151191768/019e1e27-c385-7450-a363-d30a764248b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhbPKPXgnQYYR6v30u_JL_xg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_45337c45-0630-4c0f-99b9-cfb0ce6d777f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Katy City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "901 Avenue C, Katy, TX 77493, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-b1c8-7423-a120-f93d3e322f00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e27-b1c8-7423-a120-f93d3e322f00",
        "storage_key": "property/6737460151191768/019e1e27-b1c8-7423-a120-f93d3e322f00.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://www.cityofkaty.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12571898859814934495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katy-city-hall",
      "poi_latitude": "29.7875543",
      "poi_longitude": "-95.8236655",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-391-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c3e5-76a8-8d89-2fce3b73ea37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c3e5-76a8-8d89-2fce3b73ea37",
        "storage_key": "property/6737460151191768/019e1e27-c3e5-76a8-8d89-2fce3b73ea37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPUhRZCUkQYYR31doe2dbeK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_b169919c-2411-4a2c-882a-18d639a056ae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Katy Mills",
      "poi_type": "Shopping & Retail",
      "poi_address": "5000 Katy Mills Cir, Katy, TX 77494, USA",
      "poi_short_description": "Complex with outlet stores for designer clothes, footwear & accessories, plus eateries & movies.",
      "poi_long_description": "Complex with outlet stores for designer clothes, footwear & accessories, plus eateries & movies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-8c11-7678-b506-040b4aa6b59a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e27-8c11-7678-b506-040b4aa6b59a",
        "storage_key": "property/6737460151191768/019e1e27-8c11-7678-b506-040b4aa6b59a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/katy-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=3336739692914759633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katy-mills",
      "poi_latitude": "29.7756348",
      "poi_longitude": "-95.8091819",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "100",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-644-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c31a-7140-ac55-abba18bf58eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c31a-7140-ac55-abba18bf58eb",
        "storage_key": "property/6737460151191768/019e1e27-c31a-7140-ac55-abba18bf58eb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ17sFi6EmQYYR0VchaBJ7Ti4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_3009efaa-4338-40ba-85b2-c0d729824e56",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "LaCenterra at Cinco Ranch",
      "poi_type": "Shopping & Retail",
      "poi_address": "23501 Cinco Ranch Blvd, Katy, TX 77494, USA",
      "poi_short_description": "Outdoor shopping center with business offices, clothing, footwear, beauty & gift shops, plus dining.",
      "poi_long_description": "Outdoor shopping center with business offices, clothing, footwear, beauty & gift shops, plus dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-8bf3-7598-af3c-22137a0e0d7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e27-8bf3-7598-af3c-22137a0e0d7d",
        "storage_key": "property/6737460151191768/019e1e27-8bf3-7598-af3c-22137a0e0d7d.webp",
        "width": 750,
        "height": 421
      },
      "poi_business_url": "https://lacenterra.com/?utm_source=gmb&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=17500870136583917237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lacenterra-at-cinco-ranch",
      "poi_latitude": "29.7429973",
      "poi_longitude": "-95.7750596",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "99",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-395-5533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c31a-7140-ac55-abba18bf58eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c31a-7140-ac55-abba18bf58eb",
        "storage_key": "property/6737460151191768/019e1e27-c31a-7140-ac55-abba18bf58eb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-W5CySchQYYRtY5TZ6qU3_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_debd206e-76bf-4939-93a7-8b0b0a7d00ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Katy Asian Town",
      "poi_type": "Shopping & Retail",
      "poi_address": "23119 Colonial Pkwy, Katy, TX 77449, USA",
      "poi_short_description": "Shopping center with an Asian supermarket & eateries for dim sum, poke, noodles, hot pot & more.",
      "poi_long_description": "People say this Asian town offers a massive selection of authentic Asian cuisines, including pho, Korean BBQ, sushi, ramen, and boba, along with diverse shops and an H-Mart grocery store. Visitors also highlight the lively atmosphere, making it a great place to explore and spend hours. They also mention the convenient location and clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019ea91d-5b6a-7545-92e8-56d453561320.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea91d-5b6a-7545-92e8-56d453561320",
        "storage_key": "property/6737460151191768/019ea91d-5b6a-7545-92e8-56d453561320.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://katyasiantownandmarketplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1756630455805727344&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "katy-asian-town",
      "poi_latitude": "29.7925561",
      "poi_longitude": "-95.7734323",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 346-998-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c31a-7140-ac55-abba18bf58eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c31a-7140-ac55-abba18bf58eb",
        "storage_key": "property/6737460151191768/019e1e27-c31a-7140-ac55-abba18bf58eb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpbX2uTQnQYYRcNLurxfOYBg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_5df0c76c-8c64-4306-8819-316c44d45aa5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Super Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "25108 Market Pl Dr, Katy, TX 77494",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7659225c-619a-48e4-9628-ba00997a31e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Black Bear Diner Katy",
      "poi_type": "Restaurants",
      "poi_address": "24600 Katy Fwy #900, Katy, TX 77494, USA",
      "poi_short_description": "Easygoing chain serving familiar all-day comfort food & desserts in a woodsy setting.",
      "poi_long_description": "Diners like this restaurant's delicious and hearty food, with many highlighting the huge biscuits, fluffy pancakes, and flavorful pot roast melt. They also mention the generous portions and reasonable prices, especially the \"kids eat free\" option on Tuesdays. Guests appreciate the welcoming, cozy, and family-friendly atmosphere, along with the attentive and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019ea91f-2447-74ce-8a20-8f6e240390f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea91f-2447-74ce-8a20-8f6e240390f9",
        "storage_key": "property/6737460151191768/019ea91f-2447-74ce-8a20-8f6e240390f9.webp",
        "width": 888,
        "height": 500
      },
      "poi_business_url": "https://blackbeardiner.com/location/katy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12932324304126634904&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "black-bear-diner-katy",
      "poi_latitude": "29.7867704",
      "poi_longitude": "-95.7941916",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 281-574-7902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwbxsuD8kQYYRmGueq2_YeLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_eb65e89d-0728-4416-90c6-c57ed089c8b7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Outback Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "24600 Katy Fwy Suite 2000, Katy, TX 77494, USA",
      "poi_short_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_long_description": "Guests consistently praise this steakhouse for its delicious steaks, including perfectly cooked ribeyes, and tasty appetizers such as the Bloomin' Onion and coconut shrimp. The welcoming atmosphere and friendly staff are frequently mentioned, along with the convenient takeout service.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019ea91f-255d-768a-a375-e947fd0733c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea91f-255d-768a-a375-e947fd0733c7",
        "storage_key": "property/6737460151191768/019ea91f-255d-768a-a375-e947fd0733c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.outback.com/texas/katy/24600-katy-freeway?utm_source=gmb&utm_medium=local_search&utm_campaign=website_cta&y_source=1_MTU1MDI0MzQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6177250026346269407&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "outback-steakhouse",
      "poi_latitude": "29.7867374",
      "poi_longitude": "-95.7957919",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 281-492-2225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPdXAPZ7YQIYR30okpSsAulU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_580ad09b-3911-4d05-86eb-9f0409e93fb1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Brewingz",
      "poi_type": "Restaurants",
      "poi_address": "24445 Katy Fwy #500, Katy, TX 77494",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f1b1324f-8cda-4931-987f-571ddaf065fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Walk-On's Sports Bistreaux - Katy Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "23213 Grand Cir Blvd, Katy, TX 77449, USA",
      "poi_short_description": "This game-day bar serves burgers & fried fare, plus local beers & party platters for big groups.",
      "poi_long_description": "People say this sports bar offers delicious Cajun fusion food, including popular items like the Bayou Pasta, Voodoo Shrimp and Grits, and fried alligator, with many TVs for watching games. They also highlight the reasonable prices and clean restrooms. Guests mention the staff are consistently friendly, attentive, and provide excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019ea91f-2445-70cd-b5bd-d668a31fdd4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea91f-2445-70cd-b5bd-d668a31fdd4b",
        "storage_key": "property/6737460151191768/019ea91f-2445-70cd-b5bd-d668a31fdd4b.webp",
        "width": 700,
        "height": 393
      },
      "poi_business_url": "https://locate.walk-ons.com/tx/katy/restaurants-424.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=8743984914401027836&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walk-ons-sports-bistreaux---katy-restaurant",
      "poi_latitude": "29.7868662",
      "poi_longitude": "-95.7733148",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 281-769-5959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo9yqchwnQYYR_GY_uPPfWHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5dcf6d23-fa00-4500-81f6-7b979cdf3077",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Gloria's Latin Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "23333 Grand Cir Blvd Suite 100, Katy, TX 77449, USA",
      "poi_short_description": "Family-friendly chain featuring Salvadoran & Tex-Mex favorites, plus mojitos & margaritas.",
      "poi_long_description": "People say this restaurant offers delicious Latin food with a wide variety of options, including flavorful fajitas, pupusas, and ceviche, along with great drinks and margaritas. They also highlight the excellent value, especially the outstanding kids' menu and happy hour specials. Guests consistently mention the welcoming atmosphere and the attentive, friendly staff who provide exceptional service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019ea91f-2757-7465-99c6-20362a905018.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea91f-2757-7465-99c6-20362a905018",
        "storage_key": "property/6737460151191768/019ea91f-2757-7465-99c6-20362a905018.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://gloriascuisine.com/locations/katy.html?utm_source=google&utm_medium=Yext&y_source=1_MjA1ODAzNjUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17095744980356403121&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "glorias-latin-cuisine",
      "poi_latitude": "29.78909819999999",
      "poi_longitude": "-95.7741801",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 346-365-2261",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c30b-758f-ab1f-d9e35a9dc26e",
        "storage_key": "property/6737460151191768/019e1e27-c30b-758f-ab1f-d9e35a9dc26e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSSmRbQnQYYRsY_PhHtJQO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_2c79051b-e09c-4057-855e-03d261e79b68",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Mary Jo Peckham Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5597 Gardenia Ln, Katy, TX 77493, USA",
      "poi_short_description": "Community park with a fishing pond, walking trails & an indoor swimming pool & fitness area.",
      "poi_long_description": "People say this park offers a large playground, walking trails around a pond, and opportunities for fishing and mini golf. Visitors also highlight the clean and well-maintained grounds, including spotless restrooms and ample parking. They also appreciate the family-friendly atmosphere and the variety of activities available for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-a6db-722f-b9d4-f3be5a5cdb46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e27-a6db-722f-b9d4-f3be5a5cdb46",
        "storage_key": "property/6737460151191768/019e1e27-a6db-722f-b9d4-f3be5a5cdb46.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hcp4.net/parks/mary-jo-peckham-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10120887044740132020&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mary-jo-peckham-park",
      "poi_latitude": "29.8044709",
      "poi_longitude": "-95.8197892",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c383-7698-a766-8a235a9dbfcf",
        "storage_key": "property/6737460151191768/019e1e27-c383-7698-a766-8a235a9dbfcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJs4wHltMlQYYRtKyW-SSddIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9e263463-0f37-4af3-9c73-c1e1fafbaba5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "25307 Kingsland Blvd, Katy, TX 77494, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "Reviewers consistently praise this trampoline park for its wide array of enjoyable activities for children, such as trampolines, zip lines, and rock climbing, making it an excellent venue for birthday celebrations. Guests also frequently mention the friendly and helpful staff, clean facilities, and the availability of good drinks.\n\nSome reviews mention the food can be burnt.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019ea920-8588-71f7-991e-8bf75259c2bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea920-8588-71f7-991e-8bf75259c2bb",
        "storage_key": "property/6737460151191768/019ea920-8588-71f7-991e-8bf75259c2bb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/texas-katy/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=17732911682827237047&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "29.7703392",
      "poi_longitude": "-95.8116579",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e27-c316-72aa-bb00-92f3780ae0cc",
        "storage_key": "property/6737460151191768/019e1e27-c316-72aa-bb00-92f3780ae0cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5UhSIi8nQYYRt7ZK-Dj1F_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_3b21efc8-2114-4536-8fbf-1527428a62bd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "poi_name": "Cinemark Katy and XD",
      "poi_type": "Entertainment",
      "poi_address": "1030 W Grand Pkwy N, Katy, TX 77449, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "People say this movie theater offers comfortable, reclining seats and a wide variety of fresh concessions, including popcorn and pizza. They also highlight the consistently clean facilities, including the restrooms, and the great sound and picture quality. Guests mention the friendly and attentive staff, who provide excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019ea920-8560-729f-a403-16ee19f8215c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea920-8560-729f-a403-16ee19f8215c",
        "storage_key": "property/6737460151191768/019ea920-8560-729f-a403-16ee19f8215c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-katy/cinemark-katy-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMyMDAtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=17266245091275631545&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinemark-katy-and-xd",
      "poi_latitude": "29.7867646",
      "poi_longitude": "-95.7746949",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 281-371-6008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e29-ca17-720a-ad0c-d82cec2a0190.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e29-ca17-720a-ad0c-d82cec2a0190",
        "storage_key": "property/6737460151191768/019e1e29-ca17-720a-ad0c-d82cec2a0190.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJE7HpsPwmQYYRuetQFm4Gnu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    }
  ],
  "office_hours": [
    {
      "id": "custom_550933e7-34f9-4300-82a3-f56c62b48c3d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_db34c5b6-30af-404b-bdb2-81e7ae35a751",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1ffcf4ca-84b0-48d2-b8e8-735f007b5086",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ed047279-bdc0-41f3-867f-9d7d6f2b974f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_019c7540-b3ed-4187-9b42-bf26ed4b8204",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_44ce5922-5ddc-484a-bf84-4150e6153b47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_06ce5b07-7113-4bff-bf87-23e76f3d0b0d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "rating": "5",
      "name": "Markus Vacknitz",
      "text": "The place is modern and the rooms certainly reflect that. I would like to thank my guide Konnie Aguirre for showing me around. She also did an excellent job breaking down the costs. Looking forward to updating my review later on with details about living there.",
      "date": "2026-05-15",
      "title": "false"
    },
    {
      "id": "custom_16555c10-588d-4875-b281-ed4d0ecb9fc7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "rating": "5",
      "name": "J Hwang",
      "text": "I just wanted to say how amazing the maintenance team at this apartment is! They truly do their best every single time and always make things happen as quickly and smoothly as possible. Everyone on the team is so friendly, respectful, and hardworking, and you can really tell they care about the residents.\n\nHonestly, I have never lived in an apartment where the maintenance team was this incredible. Their kindness, professionalism, and dedication really stand out, and I appreciate them so much!",
      "date": "2026-05-15",
      "title": "false"
    },
    {
      "id": "custom_073253fd-2569-4d38-a223-9372f7b978b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "rating": "5",
      "name": "Yenniffer Sandoval",
      "text": "Excelente complex y maravilloso y profesional personal de Leasing, konnie en particular es excelente, amable, siempre dispuesta a ayudar y solucionar de la mejor manera 😃",
      "date": "2026-04-17",
      "title": "false"
    },
    {
      "id": "custom_20b083f9-7204-4d80-8c9e-541ab780d496",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "rating": "5",
      "name": "Amari Flowers",
      "text": "I had the chance to tour San Remo Apartments and really enjoyed the experience. The community looked well-kept and inviting, and everything was presented nicely. The office staff was very kind and welcoming, making the tour smooth and easy to follow. It left a great impression overall!",
      "date": "2026-05-29",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_7a6f1667-4751-4102-9987-30603bb7358c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019e1e27-7256-73fc-aa98-c134668dfadf.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1e27-7256-73fc-aa98-c134668dfadf",
        "storage_key": "property/6737460151191768/019e1e27-7256-73fc-aa98-c134668dfadf.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=66b79036cd4ed130551c20ce"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993fca-ae19-765d-ad71-e2dbabeebd44",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-san-remo-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768"
    },
    {
      "lead_collector_id": "019a5027-85ee-76c1-93a2-1ecd8f14f24b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-san-remo-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "page_item_url": "san-remo-apartments-dog-park-katy-tx",
      "search_query": "san remo apartments with a dog park katy tx",
      "category": "Amenity",
      "h1_title": "San Remo Apartments with a Dog Park",
      "h2_subtitle": "Explore San Remo Apartments in Katy, TX, featuring a pet-friendly environment with a dedicated dog park. Discover our vibrant community today.",
      "page_copy": "Welcome to San Remo Apartments in Katy, TX, a perfect place for those who love both comfort and community. Our pet-friendly apartments come with an exclusive dog park, allowing your furry friends to romp and play freely. Imagine spending your afternoons in our relaxing spa or taking a dip in our refreshing pool, knowing your pets are enjoying their own space. \nAlongside the pet play area, residents have access to stylish one and two-bedroom layouts and a range of amenities including a state-of-the-art fitness center, cozy lounge, and more. Why wait? Explore San Remo Apartments today and find a modern home that offers both luxury and a friendly community atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019d076e-305c-727f-88c9-0a5cdc6a2308.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge area with comfortable seating, coffee table, and decorative elements.",
        "public_id": "019d076e-305c-727f-88c9-0a5cdc6a2308",
        "storage_key": "property/6737460151191768/019d076e-305c-727f-88c9-0a5cdc6a2308.webp",
        "width": 984,
        "height": 656
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "San Remo Apartments | Dog Park in Katy, TX",
      "seo_description": "Discover San Remo Apartments in Katy, TX with a dedicated dog park and pet-friendly amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "page_item_url": "luxury-apartments-pool-harris-county",
      "search_query": "luxury apartments with pool harris county",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Harris County",
      "h2_subtitle": "Experience luxurious living in Harris County at San Remo Apartments, featuring a resort-style pool and exceptional amenities.",
      "page_copy": "Discover luxury living at San Remo Apartments, located in the heart of Harris County. Our upscale community offers residents a lavish lifestyle with a beautiful resort-style pool, perfect for relaxing after a long day. Dive into our stylish one and two-bedroom apartments and experience top-notch features like a state-of-the-art fitness center and a rejuvenating spa.\nIn addition to the luxurious pool area, residents enjoy a variety of amenities including a cozy lounge, cable-ready units, and a pet play area for the furry members of your family. Make San Remo Apartments your new home and transform your everyday life with our unparalleled amenities in a vibrant community setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019d076e-305c-727f-88c9-0a5cdc6a2308.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge area with comfortable seating, coffee table, and decorative elements.",
        "public_id": "019d076e-305c-727f-88c9-0a5cdc6a2308",
        "storage_key": "property/6737460151191768/019d076e-305c-727f-88c9-0a5cdc6a2308.webp",
        "width": 984,
        "height": 656
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool | Harris County",
      "seo_description": "Find luxury apartments with a pool in Harris County at San Remo. Enjoy upscale living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "page_item_url": "upscale-apartments-in-unit-laundry-katy",
      "search_query": "upscale apartments with in-unit laundry katy",
      "category": "Amenity",
      "h1_title": "Upscale Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover upscale living in Katy with in-unit laundry at San Remo Apartments. Enjoy modern amenities and comfort.",
      "page_copy": "Located in the charming city of Katy, San Remo Apartments offers upscale living with the convenience of in-unit laundry facilities. Our one and two-bedroom floor plans are designed with style and functionality in mind, providing residents with a seamless blend of luxury and practicality. \nIn addition to in-unit laundry, residents enjoy access to a refreshing pool, a state-of-the-art fitness center, and a relaxing spa. The community also features a pet-friendly area, making it a perfect home for both you and your furry companions. Experience the ease and elegance of living at San Remo Apartments, where upscale living meets everyday convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019d076e-305c-727f-88c9-0a5cdc6a2308.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge area with comfortable seating, coffee table, and decorative elements.",
        "public_id": "019d076e-305c-727f-88c9-0a5cdc6a2308",
        "storage_key": "property/6737460151191768/019d076e-305c-727f-88c9-0a5cdc6a2308.webp",
        "width": 984,
        "height": 656
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Upscale Apartments with In-Unit Laundry | Katy",
      "seo_description": "Find upscale apartments with in-unit laundry in Katy at San Remo. Enjoy modern living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "page_item_url": "modern-apartments-air-conditioning-77449",
      "search_query": "modern apartments with air conditioning 77449",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Air Conditioning",
      "h2_subtitle": "San Remo Apartments in 77449 offers modern comforts like air conditioning. Discover contemporary living today.",
      "page_copy": "Welcome to San Remo Apartments, where modern living meets exceptional comfort in the 77449 area. Each of our stylish one and two-bedroom apartments is equipped with air conditioning, ensuring a cool and comfortable environment year-round. Our community is designed for those who value both style and convenience.\nBeyond air-conditioned interiors, residents have access to premium amenities including a refreshing swimming pool, a state-of-the-art fitness center, and a spa for ultimate relaxation. With pet-friendly features and a cozy lounge area, San Remo Apartments provides a perfect backdrop for a balanced lifestyle. Experience the best of modern apartment living in Katy, TX with us.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019d076e-305c-727f-88c9-0a5cdc6a2308.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge area with comfortable seating, coffee table, and decorative elements.",
        "public_id": "019d076e-305c-727f-88c9-0a5cdc6a2308",
        "storage_key": "property/6737460151191768/019d076e-305c-727f-88c9-0a5cdc6a2308.webp",
        "width": 984,
        "height": 656
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with A/C | 77449",
      "seo_description": "Explore modern apartments with air conditioning in 77449 at San Remo. Enjoy comfort and style!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-bear-creek-copperfield",
      "search_query": "fitness center apartments in bear creek copperfield",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Bear Creek",
      "h2_subtitle": "Discover San Remo Apartments in Bear Creek/Copperfield, featuring a state-of-the-art fitness center.",
      "page_copy": "At San Remo Apartments, located in the vibrant Bear Creek/Copperfield area, discover a community designed with fitness enthusiasts in mind. Our state-of-the-art fitness center is equipped with modern exercise equipment to support your active lifestyle, making it easy to stay in shape without leaving home.\nBeyond the fitness center, our community offers a variety of upscale amenities including a refreshing pool, a relaxing spa, and a dog park for your furry friends. Our stylish one and two-bedroom floor plans, paired with these exceptional amenities, offer a balance of luxury and convenience. Explore the best of apartment living at San Remo in Bear Creek/Copperfield today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019d076e-305c-727f-88c9-0a5cdc6a2308.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge area with comfortable seating, coffee table, and decorative elements.",
        "public_id": "019d076e-305c-727f-88c9-0a5cdc6a2308",
        "storage_key": "property/6737460151191768/019d076e-305c-727f-88c9-0a5cdc6a2308.webp",
        "width": 984,
        "height": 656
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center | Bear Creek",
      "seo_description": "Find apartments with a fitness center in Bear Creek/Copperfield at San Remo. Enjoy an active lifestyle in your new home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-katy-tx",
      "search_query": "one bedroom apartments katy tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Katy, TX",
      "h2_subtitle": "Explore stylish one bedroom apartments at San Remo, located in vibrant Katy, TX.",
      "page_copy": "Discover the perfect one bedroom apartment at San Remo Apartments, nestled in the heart of Katy, TX. Our thoughtfully designed floor plans offer an ideal living space with contemporary features and finishes. Each apartment is cable-ready and comes with modern conveniences like a dishwasher, making life simpler and more enjoyable.\nResidents can take advantage of a wide range of amenities, including a sparkling pool, state-of-the-art fitness center, and a serene spa. For pet lovers, our pet play area is a perfect spot for furry friends. Embrace a vibrant community and an exceptional living experience in our one bedroom apartments at San Remo.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019d076e-305c-727f-88c9-0a5cdc6a2308.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge area with comfortable seating, coffee table, and decorative elements.",
        "public_id": "019d076e-305c-727f-88c9-0a5cdc6a2308",
        "storage_key": "property/6737460151191768/019d076e-305c-727f-88c9-0a5cdc6a2308.webp",
        "width": 984,
        "height": 656
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Katy, TX",
      "seo_description": "Find stylish one bedroom apartments in Katy, TX at San Remo. Enjoy modern living and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191768",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-harris-county",
      "search_query": "two bedroom apartments harris county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Harris County",
      "h2_subtitle": "Discover spacious two bedroom apartments at San Remo, nestled in vibrant Harris County.",
      "page_copy": "Experience the comfort of spacious two bedroom apartments at San Remo Apartments, located within the bustling Harris County area. Our well-designed floor plans offer ample living space with modern features, perfect for roommates or small families. Each apartment is cable-ready, with a convenient dishwasher for everyday ease.\nOur community comes packed with lifestyle-enhancing amenities, such as a sparkling swimming pool, a fully-equipped fitness center, and a pet-friendly play area. Enjoy the perfect blend of luxury and convenience in one of our two bedroom apartments, and make San Remo Apartments your new home in Harris County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191768/019d076e-305c-727f-88c9-0a5cdc6a2308.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge area with comfortable seating, coffee table, and decorative elements.",
        "public_id": "019d076e-305c-727f-88c9-0a5cdc6a2308",
        "storage_key": "property/6737460151191768/019d076e-305c-727f-88c9-0a5cdc6a2308.webp",
        "width": 984,
        "height": 656
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Harris County",
      "seo_description": "Explore spacious two bedroom apartments in Harris County at San Remo. Enjoy modern living and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3404"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483412"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4871558"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P94SSR4H"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "281-903-5318"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "281-626-1978"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "281-984-5203"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "281-612-7430"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "281-247-6301"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "281-377-9866"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "281-688-4020"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "281-644-0340"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "281-688-5357"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "281-609-8509"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "281-819-5175"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "281-984-6268"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "361-282-6187"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "361-349-4873"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "361-245-5125"
    },
    {
      "ID": "custom_knock_psocl_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=psocl"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "281-978-2391"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "281-524-4943"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_knock_psocl_title",
      "type": "STRING",
      "value": "Paid Social"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17320117039"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "281-532-8940"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "361-470-5202"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "ebc588bb8160011e"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "361-314-7282"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_psocl_number",
      "type": "STRING",
      "value": "281-519-3937"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "281-746-6314"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "281-612-5009"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "281-248-8807"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "281-393-0251"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "281-746-6646"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "281-214-6270"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://sanremo-houston.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191768/019e84a4-81e5-707b-b195-72d7905fa003.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "281-606-3380"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "281-609-8509"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3404",
  "custom_repli_id": "5028483412",
  "custom_realpage_id": "4871558",
  "custom_knock_a_link": "https://sanremo-houston.com?utm_knock=a",
  "custom_knock_g_link": "https://sanremo-houston.com?utm_knock=g",
  "custom_knock_r_link": "https://sanremo-houston.com?utm_knock=r",
  "custom_knock_w_link": "https://sanremo-houston.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-P94SSR4H",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://sanremo-houston.com?utm_knock=al",
  "custom_knock_ar_link": "https://sanremo-houston.com?utm_knock=ar",
  "custom_knock_cl_link": "https://sanremo-houston.com?utm_knock=cl",
  "custom_knock_fb_link": "https://sanremo-houston.com?utm_knock=fb",
  "custom_knock_fl_link": "https://sanremo-houston.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://sanremo-houston.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "281-903-5318",
  "custom_knock_ads_link": "https://sanremo-houston.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://sanremo-houston.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "281-626-1978",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://sanremo-houston.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://sanremo-houston.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://sanremo-houston.com?utm_knock=ppn",
  "custom_knock_r_number": "281-984-5203",
  "custom_knock_w_number": "281-612-7430",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "281-247-6301",
  "custom_knock_amap_link": "https://sanremo-houston.com?utm_knock=amap",
  "custom_knock_ar_number": "281-377-9866",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "281-688-4020",
  "custom_knock_fb_number": "281-644-0340",
  "custom_knock_fl_number": "281-688-5357",
  "custom_knock_gp_number": "281-609-8509",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://sanremo-houston.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "281-819-5175",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://sanremo-houston.com?utm_knock=bcard",
  "custom_knock_bnr_number": "281-984-6268",
  "custom_knock_cfres_link": "https://sanremo-houston.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "361-282-6187",
  "custom_knock_lgp_number": "361-349-4873",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://sanremo-houston.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "361-245-5125",
  "custom_knock_psocl_link": "https://sanremo-houston.com?utm_knock=psocl",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "281-978-2391",
  "custom_knock_bandit_link": "https://sanremo-houston.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://sanremo-houston.com?utm_knock=flyers",
  "custom_knock_osoc_number": "281-524-4943",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_knock_psocl_title": "Paid Social",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17320117039",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "281-532-8940",
  "custom_knock_cfres_number": "361-470-5202",
  "custom_knock_chatgpt_link": "https://sanremo-houston.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "ebc588bb8160011e",
  "custom_knock_dirmail_link": "https://sanremo-houston.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "361-314-7282",
  "custom_knock_propbro_link": "https://sanremo-houston.com?utm_knock=propbro",
  "custom_knock_psocl_number": "281-519-3937",
  "custom_knock_bandit_number": "281-746-6314",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "281-612-5009",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://sanremo-houston.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "281-248-8807",
  "custom_knock_dirmail_number": "281-393-0251",
  "custom_knock_propbro_number": "281-746-6646",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "281-214-6270",
  "custom_knock_maintenance_link": "https://sanremo-houston.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191768/019e84a4-81e5-707b-b195-72d7905fa003.mp4",
  "custom_knock_maintenance_number": "281-606-3380",
  "custom_ppc_tracking_phone_number": "281-609-8509"
};

export const generatedAt = '2026-10-07T17:15:39.244Z';
